import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import _10x201 from "./10x201.png";
import _10x202 from "./10x202.png";
import _10x203 from "./10x203.png";

const width = "100";
const height = "auto";
const viewBox = "0 0 533 222";

const getDimensions = (size, sizes) => {
  if (size && typeof size.width === 'number' && typeof size.height === 'number') {
    return size
  }
  return size && sizes[size]
    ? sizes[size]
    : { width, height }
}

const getCss = (size, sizes, fillColor, fillColorRule, noStyles) => {
  if (noStyles) { return '' }
  const dimensions = getDimensions(size, sizes)
  const fillRule = fillColor && fillColorRule ? `${fillColorRule}{ fill: ${fillColor}; }` : ''
  return css`
    width: ${dimensions.width};
    height: ${dimensions.height};
    ${fillRule}
  `
}

const propsToCss = ({
  size,
  sizes,
  fillColor,
  fillColorRule,
  noStyles
}) => getCss(size, sizes, fillColor, fillColorRule, noStyles)

const Image = styled.svg`${propsToCss}`

const children = (
  <Fragment>
    <defs
      key='key-0'
    >
      <linearGradient
        id='s-2f2b1ca8ca-a'
        x1='-2539.73'
        x2='-2539.48'
        y1='348.56'
        y2='348.56'
        gradientTransform='matrix(-1 0 0 1 -2357.85 -274.8)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#595959'
        />
        <stop
          offset='.5'
          stopColor='#949494'
        />
        <stop
          offset='1'
          stopColor='#5c5c5c'
        />
      </linearGradient>
      <linearGradient
        id='s-2f2b1ca8ca-f'
        x1='-2538.54'
        x2='-2538.29'
        y1='348.51'
        y2='348.51'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-g'
        x1='-2537.43'
        x2='-2537.18'
        y1='348.45'
        y2='348.45'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-h'
        x1='-2536.32'
        x2='-2536.07'
        y1='348.37'
        y2='348.37'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-i'
        x1='-2535.13'
        x2='-2534.88'
        y1='348.3'
        y2='348.3'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-j'
        x1='-2534.02'
        x2='-2533.77'
        y1='348.23'
        y2='348.23'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-k'
        x1='-2532.89'
        x2='-2532.64'
        y1='348.17'
        y2='348.17'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-l'
        x1='-2531.7'
        x2='-2531.45'
        y1='348.09'
        y2='348.09'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-m'
        x1='-2530.59'
        x2='-2530.34'
        y1='348.03'
        y2='348.03'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-n'
        x1='-2529.48'
        x2='-2529.23'
        y1='347.97'
        y2='347.97'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-o'
        x1='-2528.29'
        x2='-2528.04'
        y1='347.93'
        y2='347.93'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-p'
        x1='-2527.18'
        x2='-2526.93'
        y1='347.81'
        y2='347.81'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-q'
        x1='-2526.11'
        x2='-2525.86'
        y1='347.74'
        y2='347.74'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-r'
        x1='-2524.92'
        x2='-2524.67'
        y1='347.71'
        y2='347.71'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-s'
        x1='-2523.81'
        x2='-2523.56'
        y1='347.64'
        y2='347.64'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-t'
        x1='-2544.22'
        x2='-2527.94'
        y1='338.09'
        y2='338.09'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-u'
        x1='-2544.21'
        x2='-2527.94'
        y1='336.64'
        y2='336.64'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-v'
        x1='-2544.21'
        x2='-2527.93'
        y1='335.26'
        y2='335.26'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-w'
        x1='-2544.2'
        x2='-2527.93'
        y1='333.81'
        y2='333.81'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-x'
        x1='-2544.2'
        x2='-2527.92'
        y1='332.42'
        y2='332.42'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-y'
        x1='-2544.33'
        x2='-2528.05'
        y1='367.79'
        y2='367.79'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-z'
        x1='-2544.33'
        x2='-2528.06'
        y1='368.99'
        y2='368.99'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-A'
        x1='-2544.32'
        x2='-2528.05'
        y1='366.4'
        y2='366.4'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-B'
        x1='-2544.32'
        x2='-2528.04'
        y1='364.95'
        y2='364.95'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-C'
        x1='-2544.31'
        x2='-2528.04'
        y1='363.57'
        y2='363.57'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-D'
        x1='-2544.31'
        x2='-2528.03'
        y1='362.11'
        y2='362.11'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-E'
        x1='-2544.3'
        x2='-2528.03'
        y1='360.73'
        y2='360.73'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-F'
        x1='-2544.3'
        x2='-2528.02'
        y1='359.28'
        y2='359.28'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-G'
        x1='-2544.29'
        x2='-2528.02'
        y1='357.9'
        y2='357.9'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-H'
        x1='-2544.29'
        x2='-2528.01'
        y1='356.44'
        y2='356.44'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-I'
        x1='-2544.28'
        x2='-2528.01'
        y1='355.03'
        y2='355.03'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-J'
        x1='-2544.28'
        x2='-2528'
        y1='353.57'
        y2='353.57'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-K'
        x1='-2544.27'
        x2='-2527.99'
        y1='352.19'
        y2='352.19'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-L'
        x1='-2544.27'
        x2='-2527.99'
        y1='350.74'
        y2='350.74'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-M'
        x1='-2544.26'
        x2='-2527.98'
        y1='349.35'
        y2='349.35'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-N'
        x1='-2544.26'
        x2='-2527.98'
        y1='347.9'
        y2='347.9'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-O'
        x1='-2544.25'
        x2='-2527.97'
        y1='346.52'
        y2='346.52'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-P'
        x1='-2544.25'
        x2='-2527.97'
        y1='345.06'
        y2='345.06'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-Q'
        x1='-2544.24'
        x2='-2527.96'
        y1='343.68'
        y2='343.68'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-R'
        x1='-2544.24'
        x2='-2527.96'
        y1='342.23'
        y2='342.23'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-S'
        x1='-2544.23'
        x2='-2527.95'
        y1='340.85'
        y2='340.85'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-T'
        x1='-2544.22'
        x2='-2527.95'
        y1='339.39'
        y2='339.39'
        gradientTransform='matrix(-.99 0 0 1 -2344.84 -267.28)'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <linearGradient
        id='s-2f2b1ca8ca-U'
        x1='164.22'
        x2='183.33'
        y1='72.74'
        y2='72.74'
        xlinkHref='#s-2f2b1ca8ca-a'
      />
      <radialGradient
        id='s-2f2b1ca8ca-V'
        cx='167.64'
        cy='69.48'
        r='1.36'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#999'
        />
        <stop
          offset='1'
          stopColor='#4d4d4d'
        />
      </radialGradient>
      <linearGradient
        id='s-2f2b1ca8ca-W'
        x1='390.74'
        x2='390.76'
        y1='344.05'
        y2='343.53'
        gradientTransform='matrix(1.11 .01 .01 1 -266.18 -276.32)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#4d4d4d'
        />
        <stop
          offset='.5'
          stopColor='#949494'
        />
        <stop
          offset='1'
          stopColor='#4d4d4d'
        />
      </linearGradient>
      <linearGradient
        id='s-2f2b1ca8ca-c'
        x1='-1724.63'
        x2='-1718.33'
        y1='354.78'
        y2='354.78'
        gradientTransform='matrix(-1 0 0 1 -1372.33 0)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='.46'
          stopColor='#d45a24'
        />
        <stop
          offset='1'
          stopColor='#a2272d'
        />
      </linearGradient>
      <linearGradient
        id='s-2f2b1ca8ca-d'
        x1='-1751.49'
        x2='-1749.91'
        y1='216.84'
        y2='216.84'
        gradientTransform='matrix(-.99 -.11 -.11 .99 -1367.89 -60.26)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='.46'
          stopColor='#f15a24'
        />
        <stop
          offset='1'
          stopColor='#c1272d'
        />
      </linearGradient>
      <linearGradient
        id='s-2f2b1ca8ca-b'
        x1='347.69'
        x2='347.86'
        y1='354.61'
        y2='354.61'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#be1e2d'
        />
        <stop
          offset='1'
          stopColor='#ee4036'
        />
      </linearGradient>
      <linearGradient
        id='s-2f2b1ca8ca-X'
        x1='346.01'
        x2='355.72'
        y1='355.72'
        y2='355.72'
        xlinkHref='#s-2f2b1ca8ca-b'
      />
      <clipPath
        id='s-2f2b1ca8ca-Y'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M721.06 362.36c0 .16 0 .32-.07.48h-.62c0-.16 0-.32.07-.48h.62z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-Z'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M720.79 363.65h-.44c.07-.55.15-1.1.24-1.6h.62c-.09.5-.17 1.05-.24 1.6h-.18z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-aa'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M721.06 362.36h-.62c.06-.4.13-.79.2-1.15h.63c-.08.36-.14.79-.21 1.15z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-ab'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M721.27 361.73l-.06.32h-.62v-.32h.63z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-ac'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M721.65 359.77a10.16 10.16 0 0 0-.38 1.44h-.63a10.06 10.06 0 0 1 .39-1.44h.62z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-ad'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M722 359.64a6 6 0 0 0-.68 2.09h-.63a6 6 0 0 1 .69-2.09z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-ae'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M721.65 359.77H721a2.45 2.45 0 0 1 .32-.63h.68a2.82 2.82 0 0 0-.35.63z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-af'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M722 359.14h-.62a.54.54 0 0 1 .3-.22h.63a.56.56 0 0 0-.31.22z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-ag'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M722 359.64h-.62a.45.45 0 0 1 .36-.24h.63a.47.47 0 0 0-.37.24z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-ah'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M721.7 359.84h.63c-.72 0-1.16 2.72-1.41 5.18h-.63c.25-2.46.71-5.18 1.41-5.18z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-ai'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M722.34 358.92z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-aj'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M722.33 359.84a.42.42 0 0 1 .28.13H722a.4.4 0 0 0-.28-.13z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-ak'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M721.69 359.4h.63a.45.45 0 0 1 .3.14H722a.42.42 0 0 0-.31-.14z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-al'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M722.34 358.92a.45.45 0 0 1 .3.14H722a.45.45 0 0 0-.31-.14z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-am'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M722.33 358.7a.46.46 0 0 1 .32.14H722a.48.48 0 0 0-.32-.14z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-an'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M722.64 359.06a.58.58 0 0 1 .12.14h-.63a.57.57 0 0 0-.11-.14z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-ao'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M722.65 358.84a1.08 1.08 0 0 1 .18.25h-.63a1.08 1.08 0 0 0-.17-.25z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-ap'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M722.86 359.39h-.62a1.6 1.6 0 0 0-.11-.19h.63z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-aq'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M722.86 359.39v.05h-.62v-.05z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-ar'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M723 359.4h-.62a2.33 2.33 0 0 0-.14-.31h.63a3.24 3.24 0 0 1 .13.31z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-as'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M722 360h.63c.67.6 1.34 5.64 1.54 11.47h-.63c-.21-5.86-.89-10.9-1.54-11.47z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-at'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M722 359.54h.63c.71.64 1.41 5.83 1.61 11.89h-.62c-.21-6.06-.92-11.25-1.62-11.89z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-au'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M723 359.87h-.62c-.06-.16-.11-.31-.16-.43h.62c.09.12.16.27.16.43z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-av'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M723.15 360h-.62c-.07-.22-.13-.42-.19-.58h.66a4.39 4.39 0 0 1 .15.58z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-aw'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M723.86 367.19h-.39a40 40 0 0 0-1.05-7.32h.58a39.09 39.09 0 0 1 1.05 7.32h-.23z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-ax'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M724.22 368.25h-.63c0-.71-.1-1.4-.15-2.06h.62c.06.66.11 1.35.16 2.06z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-ay'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M724.09 367.19q.06.63.09 1.29h-.62l-.09-1.29h.62z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-az'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M724.22 368.25c0 .35 0 .72.06 1.09h-.62c0-.37 0-.74-.07-1.09h.63z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-aA'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M724.23 369.34h-.62c0-.29 0-.58-.05-.87h.62c.02.3.04.58.05.87z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-aB'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M724.27 370.12c0 .48.05 1 .06 1.45h-.62l-.06-1.45z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-aC'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M724.28 369.34c0 .72.07 1.47.1 2.22h-.63c0-.75 0-1.5-.09-2.22h.62z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-aD'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M724.23 369.34v.78h-.62v-.77z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-2f2b1ca8ca-aE'
        transform='translate(-233.63 -274.8)'
      >
        <path
          d='M724.06 366.19h-.62a40.43 40.43 0 0 0-.91-6.21h.62a39.21 39.21 0 0 1 .91 6.21z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <linearGradient
        id='s-2f2b1ca8ca-aF'
        x1='-339.65'
        x2='-332.7'
        y1='377.32'
        y2='377.32'
        gradientTransform='translate(1054.45)'
        xlinkHref='#s-2f2b1ca8ca-c'
      />
      <linearGradient
        id='s-2f2b1ca8ca-aG'
        x1='-1037.5'
        x2='-1037.31'
        y1='375.99'
        y2='375.99'
        gradientTransform='matrix(-1 0 0 1 -317.87 0)'
        xlinkHref='#s-2f2b1ca8ca-b'
      />
      <linearGradient
        id='s-2f2b1ca8ca-aH'
        x1='-1039.44'
        x2='-1028.22'
        y1='377.28'
        y2='377.28'
        gradientTransform='matrix(-1 0 0 1 -317.87 0)'
        xlinkHref='#s-2f2b1ca8ca-b'
      />
      <linearGradient
        id='s-2f2b1ca8ca-aI'
        x1='-380.96'
        x2='-376.11'
        y1='398.88'
        y2='398.88'
        gradientTransform='rotate(-6.6 2.46 -9135.46)'
        xlinkHref='#s-2f2b1ca8ca-d'
      />
      <linearGradient
        id='s-2f2b1ca8ca-aJ'
        x1='1961.86'
        x2='1962.08'
        y1='760.61'
        y2='760.18'
        gradientTransform='rotate(-27.38 391.605 3461.088)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#d45a24'
        />
        <stop
          offset='.84'
          stopColor='#a2272d'
        />
      </linearGradient>
      <linearGradient
        id='s-2f2b1ca8ca-aK'
        x1='716.07'
        x2='716.46'
        y1='1000.86'
        y2='1000.99'
        gradientTransform='matrix(-.28 -1.17 .81 -.19 -66.1 1371.56)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#f15a24'
        />
        <stop
          offset='.83'
          stopColor='#a6272d'
        />
      </linearGradient>
      <linearGradient
        id='s-2f2b1ca8ca-aL'
        x1='542.26'
        x2='542.42'
        y1='340.03'
        y2='340.03'
        xlinkHref='#s-2f2b1ca8ca-b'
      />
      <linearGradient
        id='s-2f2b1ca8ca-aM'
        x1='540.7'
        x2='549.75'
        y1='341.12'
        y2='341.12'
        xlinkHref='#s-2f2b1ca8ca-b'
      />
      <linearGradient
        id='s-2f2b1ca8ca-e'
        x1='-1128.75'
        x2='-1128.75'
        y1='419.58'
        y2='440.04'
        gradientTransform='matrix(-1 0 0 1 -652.57 -274.8)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#c1272d'
        />
        <stop
          offset='.53'
          stopColor='#c6594b'
        />
        <stop
          offset='1'
          stopColor='#c1272d'
        />
      </linearGradient>
      <linearGradient
        id='s-2f2b1ca8ca-aN'
        x1='-1136.87'
        x2='-1120.18'
        y1='429.07'
        y2='429.07'
        xlinkHref='#s-2f2b1ca8ca-e'
      />
      <linearGradient
        id='s-2f2b1ca8ca-aO'
        x1='700.91'
        x2='711.36'
        y1='410.04'
        y2='410.04'
        xlinkHref='#s-2f2b1ca8ca-e'
      />
      <linearGradient
        id='s-2f2b1ca8ca-aP'
        x1='707.44'
        x2='717.6'
        y1='428.64'
        y2='428.64'
        xlinkHref='#s-2f2b1ca8ca-e'
      />
      <linearGradient
        id='s-2f2b1ca8ca-aQ'
        x1='700.76'
        x2='707.76'
        y1='419.79'
        y2='419.79'
        xlinkHref='#s-2f2b1ca8ca-e'
      />
      <linearGradient
        id='s-2f2b1ca8ca-aR'
        x1='358.56'
        x2='358.56'
        y1='400.34'
        y2='415.06'
        xlinkHref='#s-2f2b1ca8ca-e'
      />
      <linearGradient
        id='s-2f2b1ca8ca-aS'
        x1='342.38'
        x2='375.24'
        y1='407.12'
        y2='407.12'
        xlinkHref='#s-2f2b1ca8ca-e'
      />
      <linearGradient
        id='s-2f2b1ca8ca-aT'
        x1='364.1'
        x2='375.06'
        y1='390.12'
        y2='390.12'
        xlinkHref='#s-2f2b1ca8ca-e'
      />
      <linearGradient
        id='s-2f2b1ca8ca-aU'
        x1='343.26'
        x2='354.22'
        y1='402.45'
        y2='402.45'
        xlinkHref='#s-2f2b1ca8ca-e'
      />
      <linearGradient
        id='s-2f2b1ca8ca-aV'
        x1='353.35'
        x2='375.67'
        y1='396.89'
        y2='396.89'
        xlinkHref='#s-2f2b1ca8ca-e'
      />
      <linearGradient
        id='s-2f2b1ca8ca-aW'
        x1='354.29'
        x2='375.68'
        y1='397.28'
        y2='397.28'
        xlinkHref='#s-2f2b1ca8ca-e'
      />
    </defs>
    <g
      id='surface'
    >
      <g
        id='mainSurface'
      >
        <path
          d='M532.34 221.25L1.62 181.76l153.55-91.28 336.41 19.77 40.76 111z'
          style={{
            fill: '#4d4d4d',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M516.67 210.96L26.7 175.01l131.33-78.38 327.07 19.62 31.57 94.71z'
          style={{
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M255.22 191.78l57.86-85.85'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
      </g>
      <g
        id='surfaceBasket'
        className='basketballTwo'
      >
        <path
          d='M182.31 150.56L78.04 144.5l38.94-23.24 96.38 6.1-31.05 23.2zM503.83 172.14l-123.44-8.35v-27.22l113.75 6.51 9.69 29.06z'
        />
      </g>
      <path
        id='surfaceBasketAcross'
        className='basketballOne'
        d='M335.51 134.89l-74.68-3.78 21.21-26.84 68.17 3.84-14.7 26.78z'
      />
    </g>
    <g
      id='lines'
    >
      <g
        id='basketballAcrossLines'
        className='basketballOne'
      >
        <path
          d='M335.51 134.89l-74.68-3.78 21.21-26.84 68.17 3.84-14.7 26.78z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M569.14 409.69c-5.08 6.35-18.86 10.85-37.1 10.55-20.76-.33-40.83-5.22-37.6-14.57'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M632.94 385.9v9.34c-6.94 40.23-209.51 30.58-167.28-9.41l9.87-9.37'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-233.63 -274.8)'
        />
      </g>
      <g
        id='basketballLines'
        className='basketballTwo'
      >
        <ellipse
          cx='434.78'
          cy='413.8'
          rx='38.68'
          ry='11.48'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='rotate(-4.71 -3022.755 3116.974)'
        />
        <path
          d='M182.31 150.56L78.04 144.5l38.94-23.24 96.38 6.1-31.05 23.2z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M388.52 373.43c40.9-2.84 117.63 16.39 83 41.12-58.5 41.76-175.33 37.94-208.43 33.76'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <ellipse
          cx='611.18'
          cy='424.77'
          rx='13.57'
          ry='39.65'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='rotate(-85.83 346.61 413.01)'
        />
        <path
          d='M718.93 391.35c-101.51-6.53-148.61 11.84-148.14 30.9.6 24.69 57.44 54.23 179.22 62.34'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M503.83 172.14l-123.44-8.35v-27.22l113.75 6.51 9.69 29.06z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
      </g>
    </g>
    <image
      id='high'
      width='2173'
      height='843'
      transform='translate(4.93) scale(.24)'
      xlinkHref={_10x201}
    />
    <image
      id='medium'
      width='2179'
      height='786'
      transform='matrix(.24 0 0 .24 6.13 17.28)'
      xlinkHref={_10x202}
    />
    <image
      id='small'
      width='2103'
      height='746'
      transform='matrix(.24 0 0 .24 23.17 31.2)'
      xlinkHref={_10x203}
    />
    <g
      id='wicket'
    >
      <path
        d='M182.83 92.53l-18.11-1.03V53.06l18.11 1.06v38.41z'
        style={{
          fill: '#fff',
        }}
      />
      <path
        d='M182.6 64.24l-.85-.07V60.8l.85.07v3.37zM182.6 85.53l-.85-.07v-3.37l.85.07v3.37z'
        style={{
          fill: '#999',
        }}
      />
      <path
        d='M181.75 55.6v36.33'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-a)',
        }}
      />
      <path
        d='M180.56 55.53v36.35'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-f)',
        }}
      />
      <path
        d='M179.45 55.48v36.34'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-g)',
        }}
      />
      <path
        d='M178.34 55.36v36.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-h)',
        }}
      />
      <path
        d='M177.15 55.29V91.7'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-i)',
        }}
      />
      <path
        d='M176.04 55.23v36.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-j)',
        }}
      />
      <path
        d='M174.92 55.16v36.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-k)',
        }}
      />
      <path
        d='M173.73 55.08v36.43'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-l)',
        }}
      />
      <path
        d='M172.62 55.02v36.42'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-m)',
        }}
      />
      <path
        d='M171.51 54.95v36.43'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-n)',
        }}
      />
      <path
        d='M170.32 54.95V91.3'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-o)',
        }}
      />
      <path
        d='M169.21 54.81V91.2'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-p)',
        }}
      />
      <path
        d='M168.13 54.77v36.34'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-q)',
        }}
      />
      <path
        d='M166.94 54.71v36.4'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-r)',
        }}
      />
      <path
        d='M165.83 54.64v36.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-s)',
        }}
      />
      <path
        d='M181.75 61.2l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-t)',
        }}
      />
      <path
        d='M181.75 59.75l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-u)',
        }}
      />
      <path
        d='M181.75 58.37l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-v)',
        }}
      />
      <path
        d='M181.75 56.92l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-w)',
        }}
      />
      <path
        d='M181.75 55.54l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-x)',
        }}
      />
      <path
        d='M181.75 90.83l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-y)',
        }}
      />
      <path
        d='M181.75 92.03l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-z)',
        }}
      />
      <path
        d='M181.75 89.45l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-A)',
        }}
      />
      <path
        d='M181.75 88l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-B)',
        }}
      />
      <path
        d='M181.75 86.62l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-C)',
        }}
      />
      <path
        d='M181.75 85.17l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-D)',
        }}
      />
      <path
        d='M181.75 83.79l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-E)',
        }}
      />
      <path
        d='M181.75 82.34l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-F)',
        }}
      />
      <path
        d='M181.75 80.96l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-G)',
        }}
      />
      <path
        d='M181.75 79.51l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-H)',
        }}
      />
      <path
        d='M181.75 78.09l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-I)',
        }}
      />
      <path
        d='M181.75 76.64l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-J)',
        }}
      />
      <path
        d='M181.75 75.26l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-K)',
        }}
      />
      <path
        d='M181.75 73.81l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-L)',
        }}
      />
      <path
        d='M181.75 72.43l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-M)',
        }}
      />
      <path
        d='M181.75 70.98l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-N)',
        }}
      />
      <path
        d='M181.75 69.6l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-O)',
        }}
      />
      <path
        d='M181.75 68.15l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-P)',
        }}
      />
      <path
        d='M181.75 66.78l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-Q)',
        }}
      />
      <path
        d='M181.75 65.32l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-R)',
        }}
      />
      <path
        d='M181.75 63.95l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-S)',
        }}
      />
      <path
        d='M181.75 62.49l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-2f2b1ca8ca-T)',
        }}
      />
      <path
        d='M164.72 91.31V53.12l18.11 1.05v38.18'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-2f2b1ca8ca-U)',
        }}
      />
      <circle
        cx='167.64'
        cy='69.48'
        r='1.36'
        style={{
          fill: 'url(#s-2f2b1ca8ca-V)',
        }}
      />
      <path
        d='M167.64 69.48l3.45.16'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.5px',
          stroke: 'url(#s-2f2b1ca8ca-W)',
        }}
      />
    </g>
    <g
      id='basketball'
      className='basketballTwo'
    >
      <path
        d='M103.01 84.38h-2.04l1.41-1.4h1.74l-1.11 1.4z'
        style={{
          fill: '#4d4d4d',
        }}
      />
      <path
        d='M103.01 130.09l1.11-.68V82.98l-1.11 1.4v45.71z'
        style={{
          fill: '#666',
        }}
      />
      <path
        d='M103.01 130.09l-2.04-.12V84.38h2.04v45.71z'
        style={{
          fill: '#333',
        }}
      />
      <path
        d='M103.01 92.18l1.11-.61 7.44-12.24h-.86l-7.69 12.85z'
        style={{
          fill: '#4d4d4d',
        }}
      />
      <path
        d='M103.01 89.53v2.65l7.68-12.85h.87v-2.01l-1.27.16-7.28 12.05z'
        style={{
          fill: '#333',
        }}
      />
      <path
        d='M344 338.17c-3.34.61-6.41 5.66-7.27 10.91l.38 5.86 2.45 5.85 11.37-6.54 1.07-6.58v-4.62c-1.65-3.3-4.27-5.56-8-4.88z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M339.52 360.92l-2.5-6-.39-5.86c.91-5.6 4.14-10.42 7.35-11 4.28-.78 6.77 2.25 8.1 4.93v4.66l-1.08 6.66zm-2.31-6l2.4 5.73 11.23-6.46 1.06-6.54v-4.58c-1.31-2.61-3.73-5.56-7.89-4.8-3.13.57-6.29 5.33-7.19 10.83z'
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M340 360.05l-2.36-5.67-.36-5.41c.85-5.24 3.87-9.74 6.88-10.29 4-.73 6.35 2.1 7.6 4.61v4.35l-1 6.21h-.08zm-2-5.72l2.16 5.17 10.25-5.89 1-6v-4.19c-1.2-2.38-3.4-5.06-7.17-4.37-2.86.53-5.75 4.89-6.57 9.93z'
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M341 356.78v-7.5l8.16-4.68v7.45zm.79-7.07v5.73l6.58-3.82v-5.68z'
        style={{
          fill: '#1a1a1a',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M110.76 81.85l2.27-1.3v-2.04l-2.27 1.27v2.07z'
        style={{
          fill: '#c1272d',
        }}
      />
      <path
        d='M346.14 355.29a2.62 2.62 0 0 1 .85-.67 4 4 0 0 1 1.16-.5l-1.49-.81-2 1.12z'
        style={{
          fill: '#ea371f',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M346.14 355.73l6-1.64a.13.13 0 0 0 .11-.16.13.13 0 0 0-.16-.1l-6 1.64a.12.12 0 0 0-.11.15.14.14 0 0 0 .16.11z'
        style={{
          fill: 'url(#s-2f2b1ca8ca-c)',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M346.89 356.89a.12.12 0 0 0 .11 0 .11.11 0 0 0 0-.18l-1.19-1.05a.13.13 0 0 0-.19 0 .13.13 0 0 0 0 .18l1.19 1.06a.11.11 0 0 0 .08-.01z'
        style={{
          fill: 'url(#s-2f2b1ca8ca-d)',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M346.93 357.53a4.74 4.74 0 0 1-.16-.65l-.19-.12c.11.24.22.52.35.77zM347.67 357.73c.13.26.26.51.41.76a5 5 0 0 1-.44-1.2l-.15-.06c.06.17.11.34.18.5zM352.32 359.85a8.09 8.09 0 0 0 .56-.61c-.05-.37-.12-.72-.2-1.08a.42.42 0 0 1 0-.1q-.31.43-.66.87l.23.63c0 .08.03.19.07.29zM348.58 356.27c.08.31.16.63.25.94a5.77 5.77 0 0 0 .62.09c.05-.68.06-1.36.11-2a3.17 3.17 0 0 1 .14-1.09 8.25 8.25 0 0 0-1.73.38 3.92 3.92 0 0 1 .61 1.68zM348.16 358.44a6.06 6.06 0 0 0 .89 1.19c0-.11.07-.21.1-.32l.09-.38c-.14-.32-.26-.66-.37-1-.09-.13-.18-.25-.26-.38a8.74 8.74 0 0 1-.85-.22 4.91 4.91 0 0 0 .4 1.11zM352.74 357.89a6.73 6.73 0 0 1 .26 1.2l.05-.06c.07-.52.12-1 .14-1.58H353zM350.57 356.49c0-.3-.07-.6-.12-.9a5.35 5.35 0 0 0-.17-1c0-.09-.12-.26-.21-.28s-.24.19-.28.33a4.7 4.7 0 0 0-.09.92c0 .56 0 1.18-.08 1.81h1c.01-.3-.02-.59-.05-.88zM350.82 357.73a1.79 1.79 0 0 1 0 .23 2.29 2.29 0 0 0 .1-.23h-.12zM353.24 358.78a4.59 4.59 0 0 0 .42-.66 4.47 4.47 0 0 0 .07-.82l-.38.11c-.02.46-.05.92-.11 1.37zM352.67 357.69l.11-.16h-.13s.01.12.02.16zM350.7 358.22v-.49h-.35c.1.15.23.32.35.49zM349 357.84c.12.14.24.28.35.43l.06-.6-.48-.07a2.17 2.17 0 0 1 .07.24zM349.52 358.48c.11.15.22.29.34.43l.31.39.38-.73a.83.83 0 0 1 .07-.13c-.15-.24-.29-.48-.41-.72h-.61c-.02.28-.04.5-.08.76zM350.85 358.28a1.34 1.34 0 0 1 0 .2c.19.29.36.6.53.9.15-.18.3-.35.44-.54-.14-.37-.27-.75-.38-1.14h-.35c-.09.21-.15.4-.24.58zM353.87 357.59c.05-.12.09-.25.13-.38h-.13a1.93 1.93 0 0 1 0 .38zM351.92 358.73c.23-.29.45-.59.66-.89a2 2 0 0 1-.07-.26c-.31.05-.64.09-1 .12.16.3.29.68.41 1.03zM352.6 357.2l.46-.1c.12-.19.23-.38.34-.58a13 13 0 0 1 .9-1.88 6.51 6.51 0 0 0-1.82-.46 1 1 0 0 1 0 .23c.13.93.03 1.87.12 2.79zM355.32 355.63c0-.31-.28-.61-.77-.87a7.22 7.22 0 0 1-.25 1.92c.7-.31 1.03-.68 1.02-1.05zM347.21 358.07a10.33 10.33 0 0 0 .63 1v.1c.24.34.49.66.75 1a.64.64 0 0 0 .1.13l.15-.34a9.45 9.45 0 0 1-1-1.42 6.92 6.92 0 0 1-.59-1.34l-.25-.2c0 .35.11.7.21 1.07zM346.87 356.51a2.61 2.61 0 0 0 .28.17c-.13-.4-.25-.8-.35-1.21a8.79 8.79 0 0 0 .07 1.04z'
        style={{
          fill: 'none',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M350.8 357.36h.29a6.38 6.38 0 0 0 .22-.66c.15-.56.25-1.15.43-1.71a3.74 3.74 0 0 1 .31-.85 12 12 0 0 0-1.23 0h-.61c.35.36.4 1.46.43 1.65.07.51.12 1.04.16 1.57zM352.39 355.09a3.24 3.24 0 0 0-.05-.76c-.1-.34-.16 0-.23.11s-.12.28-.17.42c-.18.51-.27 1-.4 1.56-.08.31-.18.62-.29.92a10.59 10.59 0 0 0 1.2-.12 16.74 16.74 0 0 1-.06-2.13zM347.57 356.87a7.24 7.24 0 0 1 0-2.18 3.23 3.23 0 0 0-.75.42 16.49 16.49 0 0 0 .48 1.66zM353.5 359.44c.16-.31.3-.62.43-.94a9.58 9.58 0 0 0 .36-1.4h-.1a6 6 0 0 1-.37.95 10.58 10.58 0 0 1-.32 1.39z'
        style={{
          fill: 'none',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M115.14 82.77z'
        style={{
          fill: 'none',
        }}
      />
      <path
        d='M354.19 358.18l-.15.45a8.41 8.41 0 0 0 1-1.92 3.5 3.5 0 0 1-.43.26 10.16 10.16 0 0 1-.42 1.21zM354.43 354.7a5.46 5.46 0 0 0-.48 1 11.19 11.19 0 0 1-.6 1.2l-.07.11c.32-.09.61-.19.87-.29a8.11 8.11 0 0 0 .28-2.02zM350.36 360.55c.11-.11.21-.23.32-.35l-.5-.65-.18.45c.08.17.22.36.36.55zM353.21 359.05c0 .27-.08.53-.13.79.07-.07.14-.13.2-.2a11.72 11.72 0 0 0 .32-1.16 5.72 5.72 0 0 1-.39.57zM352.38 360c.05.14.09.27.14.4l.37-.37v-.13-.46c-.16.19-.33.37-.51.56zM347.61 355.85a7.79 7.79 0 0 0 .07 1.07 6.91 6.91 0 0 0 1 .26c-.15-.54-.28-1.09-.42-1.63 0-.14-.17-.84-.38-1l-.17.06a4 4 0 0 0-.06.71c-.03.2-.04.36-.04.53zM350.87 358.84v1.15l.42-.49zM350.09 359.44l-.36-.46-.24-.29-.06.31a6.71 6.71 0 0 0 .44.84zM346.69 355.25a.68.68 0 0 0 0 1.12 8.4 8.4 0 0 1 0-1.12zM350.71 358.58c-.14.28-.29.55-.44.82l.45.58c0-.46 0-.93-.01-1.4zM351.89 360.28l.33-.33c0-.13-.08-.25-.13-.38s-.13-.37-.2-.55l-.41.52a1.28 1.28 0 0 0 .11.2zM349.32 358.49l-.16-.2c0 .13.09.25.13.37zM349.77 360l-.12-.21c-.1-.18-.19-.37-.28-.55a3.5 3.5 0 0 1-.17.55c.14.15.29.29.44.43zM349 359.76a6.28 6.28 0 0 1-.47-.58 6.5 6.5 0 0 0 .46.61z'
        style={{
          fill: 'none',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M347.57 356.87l.11.05a7.79 7.79 0 0 1-.07-1.07v-.49a4 4 0 0 1 .06-.71h-.09a7.24 7.24 0 0 0-.01 2.22zM349.45 357.3h.17c0-.63.05-1.25.08-1.81a4.7 4.7 0 0 1 .09-.92c0-.14.1-.37.28-.33s.17.19.21.28a5.35 5.35 0 0 1 .17 1c.05.3.08.6.12.9s.06.58.08.87h.15c0-.53-.09-1.06-.16-1.59 0-.19-.08-1.29-.43-1.65l-.51.05a3.17 3.17 0 0 0-.14 1.09c-.05.75-.06 1.43-.11 2.11zM346.87 356.51a8.79 8.79 0 0 1-.07-1c.1.41.22.81.35 1.21l.18.09a16.49 16.49 0 0 1-.48-1.66l-.16.14a8.4 8.4 0 0 0 0 1.12zM347.67 354.26a.13.13 0 0 0-.11.05l.12-.05zM348.24 355.55c.14.54.27 1.09.42 1.63h.17c-.09-.31-.17-.63-.25-.94a3.92 3.92 0 0 0-.61-1.72h-.11c.21.19.35.89.38 1.03z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M354 358.63l.15-.45a10.16 10.16 0 0 0 .36-1.19l-.28.13a9.58 9.58 0 0 1-.36 1.4c-.13.32-.27.63-.43.94a10.58 10.58 0 0 0 .32-1.35 6 6 0 0 0 .37-.95l-.19.07c0 .13-.08.26-.13.38a1.93 1.93 0 0 0 0-.34l-.14.05a4.47 4.47 0 0 1-.07.82 4.59 4.59 0 0 1-.42.66c.06-.45.09-.91.11-1.37h-.16c0 .53-.07 1.06-.14 1.58l-.05.06a6.73 6.73 0 0 0-.26-1.2l.26-.4-.22.05-.11.16v-.13h-.14a2 2 0 0 0 .07.26c-.21.3-.43.6-.66.89-.12-.35-.25-.69-.39-1h-.08c.11.39.24.77.38 1.14-.14.19-.29.36-.44.54-.17-.3-.34-.61-.53-.9a1.34 1.34 0 0 0 0-.2c.09-.18.17-.37.25-.56h-.16a2.29 2.29 0 0 1-.1.23 1.79 1.79 0 0 0 0-.23h-.15v.49a6.36 6.36 0 0 0-.38-.49h-.11c.12.24.26.48.41.72a.83.83 0 0 0-.07.13l-.38.73-.31-.39c-.12-.14-.23-.28-.34-.43 0-.26.06-.53.08-.8h-.18l-.06.6c-.11-.15-.23-.29-.35-.43a2.17 2.17 0 0 0-.07-.24h-.32c.08.13.17.25.26.38.11.34.23.68.37 1l-.09.38c0 .11-.07.21-.1.32a6.06 6.06 0 0 1-.89-1.19 4.91 4.91 0 0 1-.4-1.11h-.12a5 5 0 0 0 .44 1.2c-.15-.25-.28-.5-.41-.76s-.12-.33-.18-.5l-.2-.08a6.92 6.92 0 0 0 .59 1.34 9.45 9.45 0 0 0 1 1.42l-.15.34a.64.64 0 0 1-.1-.13c-.26-.32-.51-.64-.75-1v-.1a10.33 10.33 0 0 1-.63-1c-.1-.37-.19-.72-.26-1.08l-.18-.11a4.74 4.74 0 0 0 .16.65c-.13-.25-.24-.51-.35-.77l-.16-.14a10 10 0 0 0 1.49 2.78c.11.38.23.74.37 1.1v.61a10.26 10.26 0 0 1-.09 1.57v.36c-.09.41-.32 1.6.27 1.18h.05a.73.73 0 0 0 .33.25.5.5 0 0 0 .51-.16c.14.23.33.45.58.44a.48.48 0 0 0 .37-.26.64.64 0 0 0 .1-.13.68.68 0 0 0 .92.16 1.44 1.44 0 0 0 .29-.31.74.74 0 0 0 .17.18c.36.25.52-.14.59-.41v-.1l.18.33c0 .06.12 0 .14 0a6.42 6.42 0 0 0 .09-1.75 4.6 4.6 0 0 1 .09-.84v-.06a8.15 8.15 0 0 1 .2-.82l.08-.13a9.07 9.07 0 0 0 .55-1.13v-.05-.11a10.77 10.77 0 0 0 1.41-2.71l-.22.16a8.41 8.41 0 0 1-.9 1.81zm-1.4-.59a.42.42 0 0 0 0 .1c.08.36.15.71.2 1.08a8.09 8.09 0 0 1-.56.61c0-.1-.07-.21-.11-.31l-.23-.63q.42-.41.74-.89zm-4.16 3c.07.17.15.33.22.5l-.2.22c0-.21-.07-.42-.1-.63zm-.09 0v-.28c0-.09.05.12.07.19zm.38.64l.22.44c-.1.13-.21.25-.32.38q-.09-.3-.15-.6zm1.66-.42l-.21-.19zm-.1-.31l.07-.08.4.45-.08.06a5.22 5.22 0 0 0-.35-.47zm.22.59l-.44.41-.32-.39.34-.39zm-.37-.75l-.44-.42.12-.2c.12.18.26.36.4.53zm-.1.12l-.09-.08-.33-.31c.18.08.32.21.46.35zm-.04.09l-.32.36-.32-.38.24-.35zm-.42.46l-.46.52-.22-.44a4.11 4.11 0 0 0 .38-.45zm-.46.82l.25.44-.12.14-.29.36c-.07-.18-.14-.37-.2-.56zm.17 0l-.06-.12.5-.54c.1.13.21.25.32.38-.2.19-.39.39-.58.59zm.85-.16c.14.16.27.33.4.49l-.24.29c-.13.14-.25.29-.37.44-.13-.2-.25-.41-.37-.61.15-.21.35-.41.55-.61zm.1-.09l.27-.27.18-.16c.13.12.27.25.39.38l-.45.53zm1.57-.54l.37-.39.21.42-.3.41zm.14.61l-.11.13a6.52 6.52 0 0 0-.34-.4l.17-.19c.07.15.16.36.25.46zm-.26-.79l-.27-.38.46-.42.19.38zm-.13.14l-.2.22-.34-.36.29-.26zm-.28.31l-.1.12-.07-.07a4.22 4.22 0 0 0-.27-.36l.09-.07c.07.13.2.25.32.38zm-.06.37a3.19 3.19 0 0 1 .33.4l-.11.12-.39.44-.05-.09-.26-.35zm.24.05a1.07 1.07 0 0 1-.14-.16l.1-.1c.12.13.23.27.35.41a.52.52 0 0 0-.1.11zm.39.25c.09.12.18.24.26.37s0 .11-.07.17a3.93 3.93 0 0 0-.29-.42zm.08-.09l.09-.11c.06.11.12.22.19.33v.1zm.23-.28c.1-.13.21-.26.3-.39v.06c-.06.19-.12.38-.19.57a2.98 2.98 0 0 0-.14-.24zm.13-1.08l.23-.25.15.39-.18.25zm-.1-.21c-.07-.12-.14-.24-.2-.37l.31-.3c.05.13.1.27.14.4zm-.27-1.75c.07.18.14.37.2.55s.09.25.13.38l-.33.33-.3-.54a1.28 1.28 0 0 1-.11-.2zm-.46.72l.35.64-.47.44-.33-.46-.09-.11.49-.59a.56.56 0 0 1 .02.08zm-.56-.9l.42.66-.42.49c-.02-.39-.02-.77-.03-1.15zm0 1.6l.34.48-.17.16-.13.11c-.14-.15-.27-.31-.4-.47l.31-.36a.35.35 0 0 0 0 .08zm-.58-1c.15-.27.3-.54.44-.82v1.42l-.45-.58zm-.09.15l.5.65c-.11.12-.21.24-.32.35-.14-.19-.28-.38-.41-.58zm-.69-.86l.24.29.36.46-.22.4a6.71 6.71 0 0 1-.44-.84zm-.33-.4l.16.2v.17c-.12-.16-.17-.28-.21-.41zm.21.95c.09.18.18.37.28.55l.12.21-.13.22c-.15-.14-.3-.28-.44-.43a3.5 3.5 0 0 0 .12-.59zm-.22.68c.13.15.27.29.41.43-.14-.14-.27-.28-.4-.43zm-.62-.74a6.28 6.28 0 0 0 .47.58 6.5 6.5 0 0 1-.52-.62zm.54.93c.12.14.25.27.38.4-.07.12-.15.23-.22.34l-.34-.41a1.74 1.74 0 0 0 .13-.37zm-.25.46l.32.39c-.1.14-.22.28-.33.42-.08-.16-.15-.33-.22-.49.03-.15.11-.25.18-.36zm-.72-.91l.6.76c-.05.11-.11.22-.17.33-.2-.4-.34-.79-.48-1.13zm.29 2.33c.05.21.1.41.16.61s-.16.21-.25.31c-.03-.35.02-.65.04-.95zm-.2 1.52a2 2 0 0 0 .09.33c-.22-.15-.17-.18-.14-.37zm.29.4a2.32 2.32 0 0 1-.18-.83c.11-.1.21-.21.31-.31.07.19.15.38.23.57l-.26.4c-.11.05-.12.11-.15.13zm.11.13c.06-.1.11-.21.16-.29s.11-.17.16-.25c.07.14.14.28.22.42l.11.2c-.2.1-.39.14-.7-.16zm.59-.33c-.07-.11-.12-.23-.18-.34l.33-.42.09-.1q.18.3.36.63c-.1.11-.19.23-.29.35l-.14.18c-.11-.14-.17-.24-.22-.34zm.68.62c-.32 0-.33 0-.43-.18l.07-.08.37-.44c.12.19.24.38.38.56-.13.1-.12.1-.44.1zm.47-.28c-.09-.14-.17-.29-.23-.4l-.11-.16.63-.73.09.12.25.33a5.68 5.68 0 0 0-.44.56c-.12.05-.18.19-.24.24zm1.17 0a.72.72 0 0 1-.87.3 1 1 0 0 1-.19-.17c.15-.22.27-.45.44-.66s.12-.13.17-.2c.1.13.19.27.28.41a2.64 2.64 0 0 1 .18.3zm.08-.15a4.22 4.22 0 0 1-.45-.68l.5-.59c.11.15.21.31.32.47l-.3.65a1 1 0 0 0-.12.14zm.7-.15a3.4 3.4 0 0 1-.07.34c-.25.11-.43.1-.53 0a5.38 5.38 0 0 0 .36-.82l.25.44a.15.15 0 0 1-.06.03zm.05-.31l-.23-.37.06-.15a2 2 0 0 1 .18.32c-.05.05-.05.12-.06.19zm0-.43l-.14-.24v-.09l.12.21a.49.49 0 0 0 .01.07zm0-.58l.06-.17v.26zm.25 1.51l-.18-.31v-.17a2.67 2.67 0 0 1 .13.4.43.43 0 0 0 .03.1zm0-.28a2.63 2.63 0 0 0-.17-.42.62.62 0 0 0 0-.13l.17.31a1.93 1.93 0 0 1 .02.23zm0-1.48v.93l-.15-.34c0-.27 0-.54.08-.81a.61.61 0 0 0 .07.14s.03.04.03.07zm0-.33l-.06-.13c0-.13.06-.25.1-.38v.08a3.49 3.49 0 0 0 .03.42zm0-1c0-.09-.06-.18-.1-.27l.21-.22c.04.16 0 .32-.04.48zm.12.35v-.11zm.07-1.21l-.37.37c0-.13-.09-.26-.14-.4.18-.18.35-.36.52-.56v.46zm.25.08l-.05.1v-.11l.1-.11zm-.06-.26c.05-.26.09-.52.13-.79a5.72 5.72 0 0 0 .39-.57 11.72 11.72 0 0 1-.32 1.16c.01.06-.06.12-.13.19z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M351.31 356.69a6.38 6.38 0 0 1-.22.66h.16c.11-.3.21-.61.29-.92.13-.52.22-1.05.4-1.56.05-.14.11-.28.17-.42s.13-.45.23-.11a3.24 3.24 0 0 1 .05.76 16.74 16.74 0 0 0 .06 2.13h.15c-.09-.92 0-1.86-.09-2.79a1 1 0 0 0 0-.23l-.43-.05a3.74 3.74 0 0 0-.31.85c-.21.53-.31 1.12-.46 1.68zM353.06 357.1l.22-.05.07-.11a11.19 11.19 0 0 0 .6-1.2 5.46 5.46 0 0 1 .48-1 8.11 8.11 0 0 1-.28 2.06l.15-.08a7.22 7.22 0 0 0 .25-1.92l-.25-.12a13 13 0 0 0-.9 1.88c-.11.16-.22.35-.34.54zM354.55 354.65a.16.16 0 0 0 .12-.15.17.17 0 0 0-.17-.15.16.16 0 0 0-.16.16.43.43 0 0 0 0 .05l-.05.08.25.12zM350.1 354a.09.09 0 0 0 0-.05.18.18 0 0 0-.18-.16.16.16 0 0 0-.16.17.11.11 0 0 0 0 .07.22.22 0 0 0-.09.1l.51-.05zM352.44 354.05a.15.15 0 0 0 0-.13.18.18 0 0 0-.2-.09.17.17 0 0 0-.11.11.19.19 0 0 0 0 .08l-.08.1.43.05a.4.4 0 0 0-.04-.12zM347.61 354.55v.14h.09v-.07a.12.12 0 0 1 .13 0h.11l-.14-.13a.15.15 0 0 0-.15-.16l-.12.05a.15.15 0 0 0 .08.17zM346.85 355.11v-.05a.08.08 0 0 0 0-.08.15.15 0 0 0-.15-.14.16.16 0 0 0-.16.15.17.17 0 0 0 .15.14.49.49 0 0 1 0 .12z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M347.73 354.58v.07l.17-.06a.12.12 0 0 0-.17-.01z'
        style={{
          fill: 'url(#s-2f2b1ca8ca-b)',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M350.81 353.72a9.88 9.88 0 0 0-3.13.54.15.15 0 0 1 .15.16l.14.13a8.25 8.25 0 0 1 1.73-.38.22.22 0 0 1 .09-.1.11.11 0 0 1 0-.07.16.16 0 0 1 .16-.17.18.18 0 0 1 .18.16.09.09 0 0 1 0 .05l.11.08h.61a12 12 0 0 1 1.23 0l.08-.1a.19.19 0 0 1 0-.08.17.17 0 0 1 .11-.11.18.18 0 0 1 .2.09.15.15 0 0 1 0 .13.4.4 0 0 1 0 .13 6.51 6.51 0 0 1 1.82.46l.05-.08a.43.43 0 0 1 0-.05.16.16 0 0 1 .16-.16.17.17 0 0 1 .17.15.16.16 0 0 1-.12.15v.11c.49.26.77.56.77.87s-.36.74-1 1.05l-.15.08c-.26.1-.55.2-.87.29l-.22.05-.46.1h-.15a10.59 10.59 0 0 1-1.2.12h-1.77a5.77 5.77 0 0 1-.62-.09h-.17a6.91 6.91 0 0 1-1-.26l-.11-.05-.24-.1-.18-.09a2.61 2.61 0 0 1-.28-.17l-.17-.14a.68.68 0 0 1 0-1.12.49.49 0 0 0 0-.12.17.17 0 0 1-.15-.14.16.16 0 0 1 .16-.15.15.15 0 0 1 .15.14.08.08 0 0 1 0 .08v.05a3.23 3.23 0 0 1 .75-.42v-.14a.15.15 0 0 1-.05-.24c-1 .38-1.56.92-1.55 1.52a1.14 1.14 0 0 0 .41.79l.16.14.19.12.18.11.34.16.2.08.15.06h.12a8.74 8.74 0 0 0 .85.22h.32l.48.07H351.55c.34 0 .67-.07 1-.12h.27l.22-.05h.35l.38-.11.14-.05h.13l.19-.07h.1l.28-.13a3.5 3.5 0 0 0 .43-.26l.22-.16a1.27 1.27 0 0 0 .5-.93c-.07-1.25-2.23-2.09-4.95-2.03z'
        style={{
          fill: 'url(#s-2f2b1ca8ca-X)',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M498.23 104.31l2.48.01-1.1-1.43-2.66-.05 1.28 1.47z'
        style={{
          fill: '#4d4d4d',
        }}
      />
      <path
        d='M498.23 156.89l-1.28-3.93v-50.12l1.28 1.47v52.58z'
        style={{
          fill: '#666',
        }}
      />
      <path
        d='M498.23 156.89l2.48.12v-52.69l-2.48-.01v52.58z'
        style={{
          fill: '#333',
        }}
      />
      <path
        d='M498.23 113.08l-1.28-.71-8.6-14.14h1l8.88 14.85z'
        style={{
          fill: '#4d4d4d',
        }}
      />
      <path
        d='M498.23 109.43v3.65l-8.88-14.85h-1V95.9l1.68-.13 8.2 13.66z'
        style={{
          fill: '#333',
        }}
      />
      <g
        style={{
          isolation: 'isolate',
        }}
      >
        <path
          d='M486.53 89.81h.62v5.29h-.62z'
        />
        <path
          d='M486.58 90.16h.62v4.93h-.62z'
          style={{
            fill: '#b2b2b2',
          }}
        />
        <path
          d='M486.67 90.22h.62v4.84h-.62zM486.53 95.11h.63l.25 7.55h-.62l-.26-7.55z'
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-Y)',
            }}
          >
            <path
              d='M720.59 361.49h.62c-.18.95-.32 2.06-.43 3.12h-.62c.11-1.06.25-2.17.43-3.12'
              style={{
                isolation: 'isolate',
              }}
              transform='translate(-233.63 -274.8)'
            />
          </g>
        </g>
        <path
          d='M486.58 95.1h.62l.24 7.17h-.62l-.24-7.17z'
          style={{
            fill: '#b4b4b4',
          }}
        />
        <path
          d='M486.82 102.27h.62l.02.05h-.63l-.01-.05z'
          style={{
            fill: '#bfbfbf',
          }}
        />
        <path
          d='M486.67 95.06h.62l.23 6.93h-.63l-.22-6.93z'
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-Z)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M720.63 361.84h.62c-.17.92-.31 2-.41 3h-.63c.11-1 .24-2.1.42-3'
                style={{
                  fill: '#a3a3a3',
                }}
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-aa)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M720.87 360.26h.62c-.1.36-.19.78-.28 1.23h-.62c.08-.45.18-.87.28-1.23M720.59 361.49h.62c-.18.95-.32 2.06-.43 3.12h-.62c.11-1.06.25-2.17.43-3.12'
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-ab)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M720.89 360.68h.62c-.09.34-.18.73-.26 1.16h-.62a9.61 9.61 0 0 1 .26-1.16'
                style={{
                  fill: '#9e9e9e',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M720.63 361.84h.62c-.17.92-.31 2-.41 3h-.63c.11-1 .24-2.1.42-3'
                style={{
                  fill: '#a3a3a3',
                }}
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <path
          d='M487.19 91.58h.62v8.61h-.62z'
          style={{
            fill: '#b2b2b2',
          }}
        />
        <path
          d='M487.38 93.12h.62v6.58h-.62z'
          style={{
            fill: '#121212',
          }}
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-ac)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M721.05 359.72h.62q-.09.24-.18.54h-.62q.09-.3.18-.54'
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M720.87 360.26h.62c-.1.36-.19.78-.28 1.23h-.62c.08-.45.18-.87.28-1.23'
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-ad)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M721.38 359.57h.62l-.09.13h-.62l.09-.13'
                style={{
                  fill: '#8a8a8a',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M721.29 359.7h.62l-.1.17h-.62a1 1 0 0 1 .1-.17'
                style={{
                  fill: '#8f8f8f',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M721.19 359.87h.62c0 .09-.09.18-.13.29h-.62a2 2 0 0 1 .13-.29'
                style={{
                  fill: '#949494',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M721.06 360.16h.62c-.06.15-.11.33-.17.52h-.62a4.54 4.54 0 0 1 .17-.52'
                style={{
                  fill: '#999',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M720.89 360.68h.62c-.09.34-.18.73-.26 1.16h-.62a9.61 9.61 0 0 1 .26-1.16'
                style={{
                  fill: '#9e9e9e',
                }}
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-ae)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M721.38 359.1h.62a.64.64 0 0 0-.1.13h-.62l.09-.13M721.29 359.23h.62l-.11.18h-.62a1.74 1.74 0 0 1 .11-.18M721.18 359.41h.62a3.24 3.24 0 0 0-.13.31h-.62a3.24 3.24 0 0 1 .13-.31M721.05 359.72h.62q-.09.24-.18.54h-.62q.09-.3.18-.54'
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-af)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M721.71 358.92h.63a.43.43 0 0 0-.33.18h-.63a.46.46 0 0 1 .33-.18M721.38 359.1h.62a.64.64 0 0 0-.1.13h-.62l.09-.13'
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-ag)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M721.69 359.4h.63a.45.45 0 0 0-.32.17h-.62a.43.43 0 0 1 .31-.17'
                style={{
                  fill: '#858585',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M721.38 359.57h.62l-.09.13h-.62l.09-.13'
                style={{
                  fill: '#8a8a8a',
                }}
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-ah)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M721.7 359.84h.63a.39.39 0 0 0-.3.17h-.63a.43.43 0 0 1 .3-.17'
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M721.4 360h.6l-.09.11h-.62a.44.44 0 0 1 .08-.11M721.32 360.12h.62l-.1.17h-.62a1 1 0 0 1 .1-.17M721.22 360.29h.62a2.61 2.61 0 0 0-.12.28h-.62a2.61 2.61 0 0 1 .12-.28M721.1 360.57h.62c-.05.14-.11.31-.16.49h-.62a4 4 0 0 1 .16-.49M720.94 361.06h.62c-.09.33-.18.71-.25 1.12h-.63c.08-.41.16-.79.26-1.12M720.68 362.18h.63c-.17.86-.3 1.87-.39 2.84h-.63c.1-1 .23-2 .39-2.84'
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-ai)',
            }}
          >
            <path
              d='M721.71 358.92h.63a.43.43 0 0 0-.33.18h-.63a.46.46 0 0 1 .33-.18'
              style={{
                isolation: 'isolate',
              }}
              transform='translate(-233.63 -274.8)'
            />
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-aj)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M488.08 85.04h.63-.63'
                style={{
                  fill: '#8f8f8f',
                }}
              />
              <path
                d='M721.71 359.84'
                style={{
                  fill: '#949494',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M721.74 359.84'
                style={{
                  fill: '#999',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M721.77 359.85'
                style={{
                  fill: '#9e9e9e',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M721.8 359.86'
                style={{
                  fill: '#a3a3a3',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M721.84 359.87h.62-.62'
                style={{
                  fill: '#a8a8a8',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M721.88 359.89h.62-.62'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M721.93 359.93H722.61 722a.1.1 0 0 0-.05 0'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-ak)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M488.07 84.6h.63-.63'
              />
              <path
                d='M721.83 359.43h.63-.62M721.88 359.45H722.56h-.63M721.93 359.49h.63l.06.05H722l-.06-.05'
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-al)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M488.08 84.12h.64-.64'
                style={{
                  fill: '#8f8f8f',
                }}
              />
              <path
                d='M721.72 358.92'
                style={{
                  fill: '#949494',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M721.75 358.92'
                style={{
                  fill: '#999',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M721.78 358.93'
                style={{
                  fill: '#9e9e9e',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M721.82 358.94'
                style={{
                  fill: '#a3a3a3',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M721.86 359h.62-.62'
                style={{
                  fill: '#a8a8a8',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M721.9 359H722.58 721.94'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M722 359h.62l.06.05H722V359'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-am)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M488.08 83.9h.64-.64'
              />
              <path
                d='M721.86 358.73h.62-.62M721.91 358.75H722.59 721.94M722 358.79H722.68h-.74'
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-an)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M722 359.06h.62-.62'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M722.06 359.1h.62a2.83 2.83 0 0 1 .44 1h-.63a2.86 2.86 0 0 0-.43-1'
                style={{
                  fill: '#b8b8b8',
                }}
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-ao)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M722 358.84h.62-.62M722.07 358.88h.62a3 3 0 0 1 .45 1.07h-.62a3.19 3.19 0 0 0-.45-1.07'
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-ap)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M722.06 359.1h.62a2.83 2.83 0 0 1 .44 1h-.63a2.86 2.86 0 0 0-.43-1'
                style={{
                  fill: '#b8b8b8',
                }}
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-aq)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M722.06 359.1h.62a2.83 2.83 0 0 1 .44 1h-.63a2.86 2.86 0 0 0-.43-1'
                style={{
                  fill: '#b8b8b8',
                }}
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-ar)',
            }}
          >
            <path
              d='M722.07 358.88h.62a3 3 0 0 1 .45 1.07h-.62a3.19 3.19 0 0 0-.45-1.07'
              style={{
                isolation: 'isolate',
              }}
              transform='translate(-233.63 -274.8)'
            />
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-as)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M722 360h.63-.63'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M722 360h.62a2.71 2.71 0 0 1 .39.94h-.62a2.71 2.71 0 0 0-.39-.94'
                style={{
                  fill: '#b8b8b8',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M722.41 360.94h.59a22.94 22.94 0 0 1 .59 3.34H723a26.05 26.05 0 0 0-.59-3.34'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M723 364.28h.62c.25 2 .44 4.49.53 7.16h-.63c-.09-2.67-.28-5.17-.52-7.16'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-at)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M722 359.54h.63-.63M722 359.57h.62a2.81 2.81 0 0 1 .43 1h-.62a3 3 0 0 0-.43-1M722.46 360.58h.62a26.58 26.58 0 0 1 .62 3.49h-.63a26.86 26.86 0 0 0-.61-3.49M723.07 364.07h.63c.25 2.05.44 4.61.53 7.36h-.62c-.09-2.75-.29-5.31-.54-7.36'
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-au)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M722.06 359.1h.62a2.83 2.83 0 0 1 .44 1h-.63a2.86 2.86 0 0 0-.43-1'
                style={{
                  fill: '#b8b8b8',
                }}
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-av)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M722.07 358.88h.62a3 3 0 0 1 .45 1.07h-.62a3.19 3.19 0 0 0-.45-1.07M722.52 360h.62a26.89 26.89 0 0 1 .66 3.73h-.62a28.49 28.49 0 0 0-.66-3.73'
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <path
          d='M487.19 100.19h.63l1.91 5.46h-.63l-1.91-5.46z'
          style={{
            fill: '#bfbfbf',
          }}
        />
        <path
          d='M487.38 99.69h.62l1.54 4.42h-.62l-1.54-4.42z'
          style={{
            fill: '#131313',
          }}
        />
        <path
          d='M487.38 93.12h.62l1.54 4.36h-.62l-1.54-4.36z'
          style={{
            fill: '#bfbfbf',
          }}
        />
        <path
          d='M488.92 97.48h.62v6.62h-.62z'
          style={{
            fill: '#b2b2b2',
          }}
        />
        <path
          d='M488.92 97.48v6.63l-1.54-4.42v-6.57l1.54 4.36z'
          style={{
            fill: '#d0d0d0',
          }}
        />
        <path
          d='M489.1 96.99h.62v8.67h-.62z'
          style={{
            fill: '#121212',
          }}
        />
        <path
          d='M487.19 91.58h.63l1.91 5.41h-.63l-1.91-5.41z'
          style={{
            fill: '#131313',
          }}
        />
        <path
          d='M486.79 102.66h.62l2.64 7.47h-.62l-2.64-7.47z'
        />
        <path
          d='M486.83 102.32h.63l2.51 7.1h-.63l-2.51-7.1z'
          style={{
            fill: '#bfbfbf',
          }}
        />
        <path
          d='M486.89 101.99h.63l2.4 6.81h-.62l-2.41-6.81z'
        />
        <path
          d='M489.81 102.82h.62l-.51 5.98h-.62l.51-5.98z'
          style={{
            fill: '#aeaeae',
          }}
        />
        <path
          d='M489.9 96.64h.62l-.09 6.18h-.62l.09-6.18z'
          style={{
            fill: '#b2b2b2',
          }}
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-aw)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M722.06 359.1h.62a2.83 2.83 0 0 1 .44 1h-.63a2.86 2.86 0 0 0-.43-1'
                style={{
                  fill: '#b8b8b8',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M722.49 360.13h.63a28 28 0 0 1 .64 3.65h-.62a26.17 26.17 0 0 0-.65-3.65'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M723.14 363.78h.62c.27 2.17.48 4.89.57 7.79h-.62c-.1-2.9-.3-5.62-.57-7.79'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <path
          d='M489.9 102.88h.62l-.55 6.54h-.63l.56-6.54z'
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-ax)',
            }}
          >
            <path
              d='M723.18 363.68h.62c.27 2.19.48 4.95.58 7.88h-.63c-.09-2.93-.3-5.69-.57-7.88'
              style={{
                isolation: 'isolate',
              }}
              transform='translate(-233.63 -274.8)'
            />
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-ay)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M723.14 363.78h.62c.27 2.17.48 4.89.57 7.79h-.62c-.1-2.9-.3-5.62-.57-7.79'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-az)',
            }}
          >
            <path
              d='M723.18 363.68h.62c.27 2.19.48 4.95.58 7.88h-.63c-.09-2.93-.3-5.69-.57-7.88'
              style={{
                isolation: 'isolate',
              }}
              transform='translate(-233.63 -274.8)'
            />
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-aA)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M723.14 363.78h.62c.27 2.17.48 4.89.57 7.79h-.62c-.1-2.9-.3-5.62-.57-7.79'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <path
          d='M489.99 96.63h.62l-.09 6.25h-.62l.09-6.25z'
        />
        <path
          d='M489.99 103.5h.63l-.57 6.63h-.62l.56-6.63z'
          style={{
            fill: '#aeaeae',
          }}
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-aB)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M723.14 363.78h.62c.27 2.17.48 4.89.57 7.79h-.62c-.1-2.9-.3-5.62-.57-7.79'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-aC)',
            }}
          >
            <path
              d='M723.18 363.68h.62c.27 2.19.48 4.95.58 7.88h-.63c-.09-2.93-.3-5.69-.57-7.88'
              style={{
                isolation: 'isolate',
              }}
              transform='translate(-233.63 -274.8)'
            />
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-aD)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M723.14 363.78h.62c.27 2.17.48 4.89.57 7.79h-.62c-.1-2.9-.3-5.62-.57-7.79'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <path
          d='M490.08 96.77h.62l-.08 6.73h-.63l.09-6.73z'
          style={{
            fill: '#b2b2b2',
          }}
        />
        <path
          d='M722 359.06c.74.66 1.48 6.16 1.69 12.51l-.09 6.73-.56 6.63-2.64-7.47-.26-7.56v-5.29c.27-2.69.76-5.69 1.55-5.69a.45.45 0 0 1 .31.14zm1.5 18.62l.09-6.25c-.2-6.06-.91-11.25-1.62-11.89a.42.42 0 0 0-.3-.14c-.76 0-1.22 2.89-1.48 5.46v5l.24 7.17v.05l2.51 7.1.55-6.54'
          style={{
            fill: '#d0d0d0',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M722 358.84c.75.68 1.51 6.26 1.72 12.72l-.09 6.78-.59 6.9-2.69-7.61-.26-7.71v-5.33c.28-2.81.78-5.89 1.59-5.89a.48.48 0 0 1 .32.14zm1.59 19.46l.09-6.73c-.21-6.35-1-11.85-1.69-12.51a.45.45 0 0 0-.31-.14c-.79 0-1.28 3-1.55 5.69v5.29l.26 7.56 2.64 7.47.56-6.63'
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M723.52 371.44c-.19-5.83-.87-10.87-1.54-11.47a.4.4 0 0 0-.28-.13c-.72 0-1.16 2.72-1.41 5.18v4.84l.23 6.93 2.4 6.81.51-6zm-.79 9l-1.91-5.44v-8.61l1.91 5.41v8.66'
          style={{
            fill: '#d0d0d0',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M723.61 371.43c-.2-6.06-.91-11.25-1.62-11.89a.42.42 0 0 0-.3-.14c-.76 0-1.22 2.89-1.48 5.46v5l.24 7.17v.05l2.51 7.1.55-6.54zm-.69 12.17l-2.4-6.81-.23-6.93V365c.25-2.46.69-5.18 1.41-5.18a.4.4 0 0 1 .28.13c.67.6 1.35 5.64 1.54 11.47l-.09 6.18-.51 6'
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M720.82 375l1.91 5.46v-8.66l-1.91-5.41zm.19-7.07l1.54 4.36v6.62l-1.55-4.42v-6.57'
          style={{
            fill: '#151515',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-2f2b1ca8ca-aE)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M722.52 360h.62a26.89 26.89 0 0 1 .66 3.73h-.62a28.49 28.49 0 0 0-.66-3.73'
                transform='translate(-233.63 -274.8)'
              />
              <path
                d='M723.18 363.68h.62c.27 2.19.48 4.95.58 7.88h-.63c-.09-2.93-.3-5.69-.57-7.88'
                transform='translate(-233.63 -274.8)'
              />
            </g>
          </g>
        </g>
        <path
          d='M490.04 103.54h.62l-.59 6.9h-.62l.59-6.9zM490.13 96.76h.62l-.09 6.78h-.62l.09-6.78z'
        />
      </g>
      <path
        d='M488.6 105.94l-.62-1.71.11-2.84.54 1.29-.03 3.26z'
        style={{
          fill: '#c1272d',
        }}
      />
      <path
        d='M721.29 377.55a.59.59 0 0 0-.17-1c-.77-.46-1-.34-1-.34h1.58l.55 1.29z'
        style={{
          fill: '#ea371f',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M721.6 379.51l-6.63-4.07a.15.15 0 0 1-.13-.18.17.17 0 0 1 .19-.12l6.63 4.07a.16.16 0 0 1 .13.18.16.16 0 0 1-.19.12z'
        style={{
          fill: 'url(#s-2f2b1ca8ca-aF)',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M720.51 379.37a4.56 4.56 0 0 0 .18-.75l.22-.15a9.1 9.1 0 0 1-.4.9zM719.65 379.6c-.15.3-.3.59-.47.87a5 5 0 0 0 .5-1.38l.19-.06c-.07.19-.14.38-.22.57zM714.27 382.05c-.22-.23-.43-.46-.64-.7a8.73 8.73 0 0 1 .23-1.24v-.13c.24.35.5.68.76 1-.09.24-.17.49-.26.73s-.04.22-.09.34zM718.6 377.91c-.09.36-.19.73-.29 1.09-.23 0-.46.08-.72.1-.05-.78-.06-1.57-.12-2.36a3.63 3.63 0 0 0-.16-1.25 10 10 0 0 1 2 .43 4.47 4.47 0 0 0-.71 1.99zM719.08 380.42a6.51 6.51 0 0 1-1 1.37l-.12-.36c0-.15-.07-.29-.1-.44.16-.38.3-.77.42-1.16a4.27 4.27 0 0 0 .3-.44 10.19 10.19 0 0 0 1-.25 5.06 5.06 0 0 1-.5 1.28zM713.79 379.78a8.19 8.19 0 0 0-.3 1.39l-.06-.07c-.08-.61-.13-1.21-.15-1.83l.21.05zM716.3 378.17c0-.35.09-.69.14-1a5 5 0 0 1 .2-1.22c0-.1.14-.3.24-.32s.28.22.32.38a4.74 4.74 0 0 1 .1 1.07c.05.64.06 1.35.1 2.08-.38 0-.77.05-1.19.05zM716 379.6a2.45 2.45 0 0 0 0 .27c0-.09-.08-.18-.11-.27h.11zM713.21 380.82a7.62 7.62 0 0 1-.48-.77 6 6 0 0 1-.08-.95l.44.13q.03.77.12 1.59zM713.87 379.55l-.12-.18h.15zM716.16 380.16v-.56h.39c-.12.18-.26.4-.39.56zM718.1 379.73c-.14.16-.27.32-.4.49 0-.23-.05-.46-.07-.69l.55-.08a2.29 2.29 0 0 1-.08.28zM717.51 380.47l-.38.49-.36.45c-.15-.28-.3-.56-.44-.84a.8.8 0 0 1-.08-.16c.17-.27.33-.54.47-.82h.7c.02.26.05.57.09.88zM716 380.24a1.62 1.62 0 0 1 0 .22q-.32.53-.6 1.05c-.18-.21-.35-.41-.51-.62.16-.44.31-.88.44-1.32h.39zM712.49 379.44c-.06-.14-.11-.29-.16-.44l.15.05c0 .13 0 .26.01.39zM714.74 380.75c-.26-.33-.51-.67-.76-1 0-.1 0-.2.08-.3.36.06.74.1 1.14.13-.2.42-.32.77-.46 1.17zM714 379l-.53-.11c-.14-.22-.27-.44-.39-.67a16.18 16.18 0 0 0-1-2.18 8.21 8.21 0 0 1 2.1-.53 1.58 1.58 0 0 0 0 .28c-.24 1.04-.12 2.13-.18 3.21zM710.81 377.17c0-.35.33-.71.89-1a8.69 8.69 0 0 0 .29 2.23c-.76-.4-1.19-.81-1.18-1.23zM720.18 380c-.22.39-.46.77-.72 1.15h-.06v.12c-.27.38-.56.76-.86 1.13l-.12.15c-.06-.13-.12-.26-.17-.4a9.57 9.57 0 0 0 1.17-1.64 8.49 8.49 0 0 0 .68-1.55l.39-.18c-.09.38-.19.79-.31 1.22zM720.57 378.19l-.32.2c.15-.46.29-.93.4-1.4a6.85 6.85 0 0 1-.08 1.2zM716 379.17h-.34a6.75 6.75 0 0 1-.25-.76c-.18-.66-.29-1.33-.5-2a3.73 3.73 0 0 0-.36-1 12.92 12.92 0 0 1 1.42-.05h.7a4.27 4.27 0 0 0-.49 1.9c-.04.68-.1 1.3-.18 1.91zM714.2 376.54a3.53 3.53 0 0 1 .06-.86c.11-.41.18-.06.26.11a4.34 4.34 0 0 1 .2.5c.2.58.31 1.19.46 1.79a9.48 9.48 0 0 0 .33 1.07 11.49 11.49 0 0 1-1.38-.14 20.21 20.21 0 0 0 .07-2.47zM719.77 378.61a8.94 8.94 0 0 0 0-2.53 4 4 0 0 1 .86.49c-.15.65-.34 1.29-.55 1.92zM712.92 381.57q-.27-.52-.51-1.08a12.77 12.77 0 0 1-.4-1.62h.11a5.94 5.94 0 0 0 .43 1.11 10.58 10.58 0 0 0 .37 1.59z'
        style={{
          fill: 'none',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M484.76 104.62z'
        style={{
          fill: 'none',
        }}
      />
      <path
        d='M712.12 380.12c0 .17.11.35.17.52a10 10 0 0 1-1.11-2.22 4.72 4.72 0 0 0 .5.3 12.09 12.09 0 0 0 .44 1.4zM711.85 376.09a6.88 6.88 0 0 1 .54 1.21 12 12 0 0 0 .7 1.39l.07.12a6.71 6.71 0 0 1-1-.34 8.38 8.38 0 0 1-.31-2.38zM716.54 382.86l-.36-.4q.29-.39.57-.75l.27.48c-.15.23-.31.45-.48.67zM713.26 381.13c0 .3.09.6.14.9l-.23-.22c-.14-.45-.27-.89-.37-1.34a6 6 0 0 0 .46.66zM714.21 382.22l-.16.45-.43-.43v-.14-.53c.18.22.38.43.59.65zM719.72 377.42a7.38 7.38 0 0 1-.08 1.24 8.67 8.67 0 0 1-1.13.31c.17-.63.32-1.27.48-1.89 0-.16.2-1 .44-1.11l.2.07a4.5 4.5 0 0 1 .07.82c.01.19.02.38.02.56zM716 380.88v1.33l-.49-.57zM716.85 381.57l.42-.52c.09-.12.19-.23.28-.34 0 .12 0 .24.07.35a7.55 7.55 0 0 1-.51 1c-.11-.18-.17-.33-.26-.49zM720.78 376.73a1 1 0 0 1 .34.67.93.93 0 0 1-.35.62 8 8 0 0 0 .01-1.29zM716.14 380.58c.16.32.33.64.51.95l-.52.67c0-.53 0-1.07.01-1.62zM714.78 382.54l-.39-.37.15-.44c.08-.22.15-.43.23-.64l.48.6a1.71 1.71 0 0 1-.13.23zM717.74 380.48l.19-.23-.15.43a1.42 1.42 0 0 1-.04-.2zM717.22 382.22l.15-.24c.11-.21.22-.42.32-.64 0 .22.12.43.19.64l-.5.5a2.26 2.26 0 0 1-.16-.26zM718.12 381.94c.19-.21.37-.44.54-.67a8.72 8.72 0 0 1-.53.71z'
        style={{
          fill: 'none',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M719.77 378.61l-.13.05a7.38 7.38 0 0 0 .08-1.24v-.56a4.5 4.5 0 0 0-.07-.82h.11a8.94 8.94 0 0 1 .01 2.57zM717.59 379.1h-.19c0-.73 0-1.44-.1-2.08a4.74 4.74 0 0 0-.1-1.07c0-.16-.11-.43-.32-.38s-.2.22-.24.32a5 5 0 0 0-.2 1.22c-.05.35-.1.69-.14 1l-.09 1H716c0-.61.1-1.23.18-1.84a4.27 4.27 0 0 1 .49-1.9 5.8 5.8 0 0 1 .6.06 3.63 3.63 0 0 1 .16 1.25c.1.85.11 1.64.16 2.42zM720.57 378.19a6.85 6.85 0 0 0 .08-1.2c-.11.47-.25.94-.4 1.4l-.2.1c.21-.63.4-1.27.55-1.92a1.45 1.45 0 0 1 .18.16 8 8 0 0 1 0 1.29zM719.65 375.59a.15.15 0 0 1 .13.06l-.14-.06zM719 377.08c-.16.62-.31 1.26-.48 1.89h-.2c.1-.36.2-.73.29-1.09a4.47 4.47 0 0 1 .71-2l.12.05c-.25.18-.44.99-.44 1.15z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M711.18 378.42l-.25-.19a12.82 12.82 0 0 0 1.62 3.14l.06.12a.07.07 0 0 0 0 .06 10.64 10.64 0 0 0 .65 1.31 1.09 1.09 0 0 0 .08.15 7.77 7.77 0 0 1 .24.95.06.06 0 0 0 0 .07 5.23 5.23 0 0 1 .1 1 7.21 7.21 0 0 0 .11 2 .09.09 0 0 0 .16 0l.21-.38v.11c.08.32.27.76.68.48a.8.8 0 0 0 .2-.21 1.42 1.42 0 0 0 .34.35.77.77 0 0 0 1.06-.18l.1.15a.6.6 0 0 0 .43.29c.29 0 .51-.24.67-.5a.6.6 0 0 0 .6.18.75.75 0 0 0 .38-.28c.69.48.42-.9.32-1.37a2.83 2.83 0 0 0 0-.41 12.27 12.27 0 0 1-.1-1.82 5.45 5.45 0 0 0 0-.7c.15-.41.3-.84.42-1.27a11.33 11.33 0 0 0 1.72-3.21l-.18.15a9.1 9.1 0 0 1-.4.9 4.56 4.56 0 0 0 .18-.75l-.21.13c-.08.41-.18.82-.3 1.24s-.46.77-.72 1.15h-.06v.12c-.27.38-.56.76-.86 1.13l-.12.15c-.06-.13-.12-.26-.17-.4a9.57 9.57 0 0 0 1.17-1.64 8.49 8.49 0 0 0 .68-1.55l-.22.1c-.07.19-.14.38-.22.57s-.3.59-.47.87a5 5 0 0 0 .5-1.38l-.13.05a5.06 5.06 0 0 1-.47 1.28 6.51 6.51 0 0 1-1 1.37l-.12-.36c0-.15-.07-.29-.1-.44.16-.38.3-.77.42-1.16a4.27 4.27 0 0 0 .3-.44h-.38a2.29 2.29 0 0 1-.08.28c-.14.16-.27.32-.4.49 0-.23-.05-.46-.07-.69h-.21c0 .3.05.61.09.92l-.38.49-.36.45c-.15-.28-.3-.56-.44-.84a.8.8 0 0 1-.08-.16c.17-.27.33-.54.47-.82h-.14c-.15.19-.29.37-.42.57v-.56H716a2.45 2.45 0 0 0 0 .27c0-.09-.08-.18-.11-.27h-.2l.29.65a1.62 1.62 0 0 1 0 .22q-.32.53-.6 1.05c-.18-.21-.35-.41-.51-.62.16-.44.31-.88.44-1.32h-.09c-.17.39-.32.79-.46 1.19-.26-.33-.51-.67-.76-1 0-.1 0-.2.08-.3h-.16v.15l-.12-.18-.26-.06.3.46a8.19 8.19 0 0 0-.3 1.39l-.06-.07c-.08-.61-.13-1.21-.15-1.83h-.19q0 .79.12 1.59a7.62 7.62 0 0 1-.48-.77 6 6 0 0 1-.08-.95l-.17-.05v.39c-.06-.14-.11-.29-.16-.44l-.21-.09a5.94 5.94 0 0 0 .43 1.11 10.58 10.58 0 0 0 .37 1.55q-.27-.52-.51-1.08a12.77 12.77 0 0 1-.4-1.62l-.33-.15a12.09 12.09 0 0 0 .42 1.38c0 .17.11.35.17.52a10 10 0 0 1-1.13-2.18zm3.49 2.54c-.09.24-.17.49-.26.73s-.09.24-.14.36c-.22-.23-.43-.46-.64-.7a8.73 8.73 0 0 1 .23-1.24v-.13c.29.32.55.65.81 1.02zm4.13 2.52c0 .25-.06.49-.1.73l-.24-.26c.09-.19.17-.38.25-.57zm0-.21l.09-.22v.33zm-.09 1.1c0 .23-.1.47-.17.7-.13-.15-.25-.3-.38-.44.09-.17.18-.34.26-.52zm-2-1l-.25.21zm-.57.38l-.08-.08.46-.52.08.09c-.18.2-.33.36-.48.54zm.69-.25l.39.45-.37.45-.5-.47zm-.15-.54c.16-.2.32-.41.46-.62l.14.23-.51.49zm.69-.24v.05l-.38.36-.1.09zm.11.19l.27.41-.36.43-.37-.41zm.37.53a4.4 4.4 0 0 0 .43.52l-.25.51-.54-.61zm.6 1.82c-.07.22-.15.43-.24.64q-.15-.21-.33-.42l-.14-.16c.1-.17.2-.34.29-.51zm-.83-.07c-.21-.24-.43-.46-.66-.68l.37-.45.58.63s0 .09-.08.14zm-.09.16l-.43.7-.43-.51-.28-.33.46-.57c.21.26.44.49.66.74zm-1.24-.25c-.17-.21-.35-.41-.53-.61.15-.16.3-.3.46-.45l.21.19.31.3zm-1.69-.68c-.12-.15-.23-.31-.35-.47.08-.16.17-.32.25-.49l.43.46c-.14.19-.24.36-.35.53zm.48-.34l.2.22-.4.47-.12-.15zm-.46-.86c.07-.15.15-.29.23-.44l.52.49-.3.44zm.89.17l.33.3-.38.42-.24-.26zm.44.4l.09.08-.31.42a.46.46 0 0 0-.07.07l-.12-.13c.11-.12.25-.23.39-.41zm.21 1.48l-.31.41-.07.11-.45-.51a.86.86 0 0 1-.13-.14c.12-.16.25-.32.38-.47.19.22.42.42.56.63zm-1.07-.26l-.12-.13c.13-.16.27-.32.41-.47l.11.12-.16.18a3.15 3.15 0 0 0-.26.29zm-.1.13l-.34.48c0-.06 0-.13-.08-.19s.2-.29.31-.43zm-.48.13v-.12l.21-.38.1.12zm-.15-.42c-.08-.22-.16-.44-.23-.66v-.07l.35.45c-.04.12-.09.22-.14.31zm-.23-1.06c-.07-.1-.13-.2-.2-.29l.17-.45.27.28zm.06-1c.05-.15.11-.31.16-.47l.37.36c-.08.14-.16.28-.23.42zm1.08-1.11a1.71 1.71 0 0 1-.13.23l-.34.62-.39-.37.15-.44c.08-.22.15-.43.23-.64zm.11.14l.57.68-.1.13c-.13.17-.26.35-.38.53l-.55-.51c.13-.25.27-.5.41-.74a.41.41 0 0 0 .03-.08zm.6.38l-.49-.57.48-.76c.03.45.03.89.03 1.34zm.08.43c.12.14.23.28.35.41-.15.19-.3.37-.46.55l-.15-.13-.2-.18c.13-.19.26-.38.4-.56zm.62-1.09l-.52.67v-1.64c.16.32.33.64.51.95zm.36.64c-.15.23-.31.45-.48.67l-.36-.4q.29-.39.57-.75zm.6-1.13a7.55 7.55 0 0 1-.51 1c-.08-.16-.17-.31-.26-.47l.42-.52c.09-.12.19-.23.28-.34 0 .11.02.28.05.34zm.16-.38a1.42 1.42 0 0 1 0-.2l.19-.23zm.1 1.3l-.5.5a2.26 2.26 0 0 1-.16-.26l.15-.24c.11-.21.22-.42.32-.64.03.23.1.44.17.67zm.08.2l-.46.5v-.05l.47-.49zm.17-.2c.19-.21.37-.44.54-.67a8.72 8.72 0 0 1-.56.7zm.11.76l-.39.46-.26-.38.45-.47a3.6 3.6 0 0 0 .18.4zm.35.51c-.08.19-.16.38-.25.57a6 6 0 0 1-.39-.49l.37-.45zm.07-.16l-.2-.38c.24-.29.47-.59.7-.88-.18.43-.34.85-.52 1.27zm.26 2.49c-.1-.12-.19-.24-.29-.35.07-.23.14-.47.19-.7 0 .36.07.71.08 1.06zm0 1.08a1.86 1.86 0 0 0 .1-.39c.05.24.1.28-.04.4zm-.34-.11l-.31-.47a4.77 4.77 0 0 0 .26-.66l.36.36a2.19 2.19 0 0 1 0 .36 1.72 1.72 0 0 1-.18.6s-.06-.08-.12-.18zm-.77.44l.12-.24c.09-.16.18-.32.26-.48l.19.28c.06.1.11.23.18.34-.35.32-.58.27-.74.12zm-.13-.13l-.16-.21-.34-.41.42-.73.1.12c.13.16.26.32.38.49-.06.13-.13.26-.2.39s-.12.24-.19.36zm-1 .2a6.16 6.16 0 0 0 .44-.65c.14.17.29.34.43.52l.07.09c-.11.19-.12.19-.49.2s-.39.02-.48-.15zm-.31-.48c-.15-.22-.33-.44-.5-.65l.28-.38.1-.14.73.84-.12.2c-.08.11-.17.29-.27.45zm-1.14.33c.07-.12.13-.24.2-.34l.32-.48.2.24c.19.24.34.5.51.76a.77.77 0 0 1-.22.19.82.82 0 0 1-1-.35zm-.16-.32c-.13-.24-.24-.5-.35-.75.12-.19.24-.37.37-.54l.57.68a5.52 5.52 0 0 1-.51.78.89.89 0 0 1-.11-.16zm-.75-.08a5.09 5.09 0 0 1 .3-.5 5.16 5.16 0 0 0 .41.94c-.12.15-.32.16-.61 0a2.74 2.74 0 0 1-.09-.39s-.04-.01-.04-.04zm-.07-.52l.21-.38.07.18c-.09.14-.18.28-.26.43zm0-.39l.14-.24a.69.69 0 0 0 0 .1 2.61 2.61 0 0 0-.17.28.66.66 0 0 0-.03-.13zm0-.43v-.3c0 .06.05.13.08.2a.31.31 0 0 0-.16.11zm-.26 1.58s.1-.3.16-.45v.19c-.07.12-.14.24-.2.36s-.03-.07-.04-.09zm0-.54l.2-.36v.15a4.14 4.14 0 0 0-.19.49 2.64 2.64 0 0 1-.14-.27zm0-1.52a1.3 1.3 0 0 1 .08-.17c0 .31.07.62.09.94-.06.13-.12.26-.17.39a9.55 9.55 0 0 0 0-1.07zm-.12-.79v-.09c0 .14.08.29.11.43a1 1 0 0 1-.07.15 4.33 4.33 0 0 0-.17-.48zm0-1.22l.24.25c0 .11-.07.21-.11.31-.23-.17-.27-.36-.31-.55zm0 .81v.15a.83.83 0 0 1-.22-.14zm-.08-1.39v-.53c.19.22.4.44.6.65l-.16.45-.43-.43zm-.28.16l.11.12a.62.62 0 0 1 0 .13l-.06-.11v-.07zm-.14-.45c-.14-.45-.27-.89-.37-1.34a6 6 0 0 0 .46.66c0 .3.09.6.14.9z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M715.45 378.4a6.75 6.75 0 0 0 .25.76h-.19a9.48 9.48 0 0 1-.33-1.07c-.15-.6-.26-1.21-.46-1.79a4.34 4.34 0 0 0-.2-.5c-.08-.17-.15-.52-.26-.11a3.53 3.53 0 0 0-.06.86 20.21 20.21 0 0 1-.07 2.47h-.17c.1-1.06 0-2.15.1-3.21a1.58 1.58 0 0 1 0-.28l.5-.05a3.73 3.73 0 0 1 .36 1c.24.59.35 1.26.53 1.92zM713.43 378.87l-.27-.06-.07-.12a12 12 0 0 1-.7-1.39 6.88 6.88 0 0 0-.54-1.21 8.38 8.38 0 0 0 .32 2.38l-.18-.08a8.69 8.69 0 0 1-.29-2.23l.3-.16a16.18 16.18 0 0 1 1 2.18c.16.25.29.47.43.69zM711.7 376a.16.16 0 0 1-.13-.17.17.17 0 0 1 .19-.17.17.17 0 0 1 .18.18.13.13 0 0 1 0 .06l.06.08-.29.14zM716.84 375.33v-.05a.2.2 0 0 1 .2-.19c.1 0 .2.09.19.19a.19.19 0 0 1 0 .08.45.45 0 0 1 .1.13 5.8 5.8 0 0 0-.6-.06.57.57 0 0 1 .11-.1zM714.14 375.34a.17.17 0 0 1 0-.14.2.2 0 0 1 .23-.11.16.16 0 0 1 .13.12.38.38 0 0 1 0 .1l.09.11-.5.05a.88.88 0 0 1 .05-.13zM719.72 375.92v.16h-.11V376a.15.15 0 0 0-.16 0l-.12-.05a1.07 1.07 0 0 1 .16-.14.17.17 0 0 1 .17-.19l.14.06a.17.17 0 0 1-.08.24zM720.6 376.57a.43.43 0 0 1 0-.05.17.17 0 0 1 0-.1.18.18 0 0 1 .19-.16.17.17 0 0 1 .17.17.17.17 0 0 1-.17.16.66.66 0 0 1 0 .14 1.45 1.45 0 0 0-.19-.16z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M719.59 376v.08l-.2-.07a.15.15 0 0 1 .2-.01z'
        style={{
          fill: 'url(#s-2f2b1ca8ca-aG)',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M716 375a11.26 11.26 0 0 1 3.62.62.17.17 0 0 0-.17.19 1.07 1.07 0 0 0-.16.14 10 10 0 0 0-2-.43.45.45 0 0 0-.1-.13.19.19 0 0 0 0-.08c0-.1-.09-.18-.19-.19a.2.2 0 0 0-.2.19v.05a.57.57 0 0 0-.13.1h-.7a12.92 12.92 0 0 0-1.42.05l-.09-.11a.38.38 0 0 0 0-.1.16.16 0 0 0-.13-.12.2.2 0 0 0-.23.11.17.17 0 0 0 0 .14.88.88 0 0 0 0 .15 8.21 8.21 0 0 0-2.1.53l-.06-.08a.13.13 0 0 0 0-.06.17.17 0 0 0-.18-.18.17.17 0 0 0-.19.17.16.16 0 0 0 .13.17v.12c-.56.3-.88.66-.89 1s.42.86 1.18 1.22l.18.08a6.71 6.71 0 0 0 1 .34l.27.06.53.11h.17a11.49 11.49 0 0 0 1.38.14h.7c.42 0 .81 0 1.19-.05h.19c.26 0 .49-.06.72-.1h.2a8.67 8.67 0 0 0 1.13-.31l.13-.05.28-.12.2-.1.32-.2.2-.17a.93.93 0 0 0 .35-.62 1 1 0 0 0-.34-.67.66.66 0 0 0 0-.14.17.17 0 0 0 .17-.16.17.17 0 0 0-.17-.17.18.18 0 0 0-.19.16.17.17 0 0 0 0 .1.43.43 0 0 0 0 .05 4 4 0 0 0-.86-.49V376a.17.17 0 0 0 .06-.27c1.12.44 1.81 1.07 1.79 1.76a1.29 1.29 0 0 1-.48.91l-.18.15-.22.15-.21.13-.39.18-.22.1-.19.06-.13.05a10.19 10.19 0 0 1-1 .25h-.38l-.55.08H715.25c-.4 0-.78-.07-1.14-.13h-.31l-.26-.06-.21-.05h-.19l-.44-.13-.17-.05-.15-.05-.21-.09h-.11l-.33-.15a4.72 4.72 0 0 1-.5-.3l-.25-.19a1.42 1.42 0 0 1-.58-1.07c-.01-1.42 2.47-2.38 5.6-2.28z'
        style={{
          fill: 'url(#s-2f2b1ca8ca-aH)',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M717.54 379.57a.17.17 0 0 1-.13-.05.14.14 0 0 1 0-.21l4.57.07a.16.16 0 0 1 .22 0 .14.14 0 0 1 0 .22l-4.57-.07a.19.19 0 0 1-.09.04z'
        style={{
          fill: 'url(#s-2f2b1ca8ca-aI)',
        }}
        transform='translate(-233.63 -274.8)'
      />
    </g>
    <g
      id='basketballAcross'
      className='basketballOne'
    >
      <path
        d='M317.92 106.78l-2.1-.13V61.8l2.1-.01v44.99z'
        style={{
          fill: '#666',
        }}
      />
      <path
        d='M317.92 106.78l1.04-.59V61.45l-1.04.34v44.99z'
        style={{
          fill: '#333',
        }}
      />
      <path
        d='M318.96 61.45l-1.04.34-2.67.01 1.85-.42 1.86.07z'
        style={{
          fill: '#858589',
        }}
      />
      <path
        d='M317.65 78.12l-1.83-.15-3.22-14.24 1.83.15 3.22 14.24z'
        style={{
          fill: '#4d4d4d',
        }}
      />
      <path
        d='M317.65 73.49v4.63l-3.21-14.24h-2.02l.97-1h1.86l2.4 10.61z'
        style={{
          fill: '#333',
        }}
      />
      <path
        d='M560.25 330.25c-1.41-4.76-6.46-8.29-12.49-8.29s-10.46 2.15-11.86 6.91v6.08l5.87 6.18 12.14.71 6.3-5.49v-.08z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M554 341.92l-12.21-.71-5.95-6.21v-6.1c1.34-4.56 5.47-7 11.94-7 6 0 11.12 3.43 12.57 8.35v6.17zm-12.14-.87l12.08.7 6.25-5.45v-6c-1.43-4.84-6.53-8.22-12.4-8.22-6.39 0-10.46 2.36-11.78 6.83v6z'
        style={{
          fill: '#1a1a1a',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M553.38 341.31l-11.38-.66-5.54-5.85V329c1.25-4.28 5.11-6.55 11.16-6.55 5.56 0 10.39 3.22 11.75 7.82V336.08l-.07.12zm-11.16-1.16l11 .64 5.64-4.87v-5.5c-1.31-4.37-5.93-7.41-11.25-7.41-4 0-9.15 1.06-10.66 6.14v5.48z'
        style={{
          fill: '#1a1a1a',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M314.92 66.2l-2.48-.14v-2.33l2.48.13v2.34z'
        style={{
          fill: '#c1272d',
        }}
      />
      <path
        d='M552.06 339.1l-9.16-.51V331l9.16.5zm-8.54-1.1l7.93.44v-6.36l-7.93-.43z'
        style={{
          fill: '#1a1a1a',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M547.58 339.45a3 3 0 0 0-1.15-.25 4.5 4.5 0 0 0-1.36.08l1-.75 2.47.13z'
        style={{
          fill: '#ea371f',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M547 340.57l-5.79.23a.13.13 0 0 1-.07-.24l5.78-.23a.13.13 0 0 1 .16.08.13.13 0 0 1-.08.16z'
        style={{
          fill: 'url(#s-2f2b1ca8ca-aJ)',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M549.62 341.07a.22.22 0 0 1 0 .14c0 .07-.11.07-.17 0l-2.06-.64a.22.22 0 0 1 0-.23.09.09 0 0 1 .17 0l2.06.63a.19.19 0 0 1 0 .1z'
        style={{
          fill: 'url(#s-2f2b1ca8ca-aK)',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M541.55 342.88a5.81 5.81 0 0 1-.15-.63l-.17-.12c.1.25.2.51.32.75zM542.24 343.08c.12.25.25.49.39.73a4.46 4.46 0 0 1-.41-1.16l-.15-.06c.06.16.11.33.17.49zM546.59 345.14c.18-.19.35-.39.51-.59a8.85 8.85 0 0 0-.19-1v-.11c-.2.29-.4.57-.61.85l.21.62c0 .03.04.09.08.23zM543.09 341.65c.08.31.15.61.24.92l.58.09c0-.67.05-1.33.1-2a2.93 2.93 0 0 1 .13-1.05 7.35 7.35 0 0 0-1.62.36 3.87 3.87 0 0 1 .57 1.68zM542.7 343.77a5.27 5.27 0 0 0 .83 1.15c0-.1.07-.2.09-.3l.09-.37c-.13-.32-.24-.65-.34-1-.09-.12-.17-.25-.25-.37a7.52 7.52 0 0 1-.79-.21 4.76 4.76 0 0 0 .37 1.1zM547 343.23a7.35 7.35 0 0 1 .24 1.17v-.06c.06-.51.1-1 .12-1.54h-.17zM545 341.87c0-.29-.07-.59-.11-.88a4.34 4.34 0 0 0-.16-1c0-.09-.11-.26-.2-.28s-.22.19-.26.32a4.56 4.56 0 0 0-.08.9c0 .55 0 1.15-.07 1.76h.95c-.07-.26-.07-.54-.07-.82zM545.19 343.07v.23a1.57 1.57 0 0 0 .09-.23h-.1zM547.44 344.1a6.18 6.18 0 0 0 .4-.64 4.25 4.25 0 0 0 0-.8l-.35.1c.04.45 0 .9-.05 1.34zM546.91 343l.1-.16h-.12s.01.16.02.16zM545.07 343.55v-.48h-.32a5.92 5.92 0 0 1 .32.48zM543.5 343.19c.11.13.21.27.32.41v-.59a3.32 3.32 0 0 1-.44-.06 2.17 2.17 0 0 0 .12.24zM544 343.81l.31.42c.1.12.2.25.29.38l.36-.72.06-.13c-.13-.23-.26-.46-.38-.69h-.56c-.08.22-.08.48-.08.74zM545.22 343.61v.19c.18.29.34.59.49.89l.42-.53c-.13-.37-.26-.74-.36-1.11h-.32zM548 342.94c.05-.12.08-.25.12-.37H548v.37zM546.21 344.05c.21-.29.42-.57.61-.87l-.06-.25a8.58 8.58 0 0 1-.92.11c.16.33.26.67.37 1.01zM546.84 342.55a2.72 2.72 0 0 0 .43-.09c.11-.18.22-.37.32-.57a13.74 13.74 0 0 1 .84-1.83 6.05 6.05 0 0 0-1.69-.45 2.15 2.15 0 0 1 0 .23c.12.9.02 1.82.1 2.71zM549.39 341c0-.3-.27-.6-.72-.85a7.81 7.81 0 0 1-.24 1.88c.62-.28.96-.65.96-1.03zM541.81 343.4c.19.33.38.66.59 1v.1q.33.5.69 1l.1.12c.05-.11.1-.22.14-.33a9.38 9.38 0 0 1-.95-1.38 6.5 6.5 0 0 1-.55-1.31l-.31-.15c.12.25.2.6.29.95zM541.5 341.88a1.67 1.67 0 0 0 .26.17c-.12-.39-.23-.78-.32-1.17a6.63 6.63 0 0 0 .06 1z'
        style={{
          fill: 'none',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M545.16 342.71h.28c.07-.21.14-.43.2-.64.14-.56.23-1.13.4-1.68a3.4 3.4 0 0 1 .29-.82 8.45 8.45 0 0 0-1.14 0 5.17 5.17 0 0 0-.57 0 3.61 3.61 0 0 1 .39 1.6c.07.51.12 1.03.15 1.54zM546.64 340.5a3 3 0 0 0 0-.73c-.09-.34-.15 0-.21.1s-.11.27-.16.41a13.46 13.46 0 0 0-.37 1.52q-.12.45-.27.9a9.2 9.2 0 0 0 1.11-.12 20.47 20.47 0 0 1-.1-2.08zM542.15 342.24a8 8 0 0 1 0-2.13 3.59 3.59 0 0 0-.69.41c.12.55.27 1.08.44 1.62zM547.68 344.74c.15-.3.28-.61.41-.91a10.92 10.92 0 0 0 .33-1.37h-.1a4.68 4.68 0 0 1-.34.93 8.56 8.56 0 0 1-.3 1.35z'
        style={{
          fill: 'none',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M309.64 68.12z'
        style={{
          fill: 'none',
        }}
      />
      <path
        d='M548.32 343.51c0 .15-.08.3-.13.44a8 8 0 0 0 .89-1.87 3 3 0 0 1-.4.25 9.65 9.65 0 0 1-.36 1.18zM548.55 340.12a5.42 5.42 0 0 0-.44 1 11.34 11.34 0 0 1-.57 1.16l-.06.11a6.35 6.35 0 0 0 .81-.28 8.09 8.09 0 0 0 .26-1.99zM544.75 345.83l.3-.35-.46-.63-.22.41zM547.41 344.37c0 .25-.07.5-.12.76l.19-.19c.11-.38.22-.75.3-1.13-.12.19-.24.38-.37.56zM546.64 345.28c0 .13.09.26.13.39l.35-.36a.59.59 0 0 1 0-.13v-.44c-.12.18-.32.36-.48.54zM542.19 341.24a6 6 0 0 0 .06 1 6.35 6.35 0 0 0 .92.26q-.21-.8-.39-1.59c0-.14-.16-.81-.36-.94l-.16.07a4.74 4.74 0 0 0 0 .69c-.06.19-.07.35-.07.51zM545.23 344.15v1.13l.39-.48c-.12-.22-.26-.43-.39-.65zM544.5 344.74l-.33-.44c-.08-.1-.15-.2-.23-.29 0 .1 0 .2-.05.3a5.66 5.66 0 0 0 .4.82c.08-.13.14-.26.21-.39zM541.33 340.66a.8.8 0 0 0-.27.56.84.84 0 0 0 .28.53 8 8 0 0 1-.01-1.09zM545.08 343.91l-.41.79.42.56c0-.44 0-.9-.01-1.35zM546.18 345.56c.11-.1.21-.21.31-.32l-.12-.37-.18-.54-.39.51c0 .07.07.13.1.2s.19.34.28.52zM543.79 343.82l-.16-.2c0 .12.08.24.13.36zM544.21 345.29l-.12-.21c-.09-.17-.18-.35-.26-.53a3.24 3.24 0 0 1-.16.53l.41.43c.04-.08.09-.15.13-.22zM543.48 345.05c-.15-.18-.3-.37-.44-.56.14.2.28.4.43.59z'
        style={{
          fill: 'none',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M542.15 342.24h.1a6 6 0 0 1-.06-1v-.47a4.74 4.74 0 0 1 0-.69h-.09a8 8 0 0 0 .05 2.16zM543.91 342.66h.16c0-.61 0-1.21.07-1.76a4.56 4.56 0 0 1 .08-.9c0-.13.1-.36.26-.32s.16.19.2.28a4.34 4.34 0 0 1 .16 1c0 .29.08.59.11.88s0 .56.07.84h.14c0-.51-.08-1-.15-1.55a3.61 3.61 0 0 0-.39-1.6l-.48.05a2.93 2.93 0 0 0-.13 1.05c-.01.7-.01 1.37-.1 2.03zM541.5 341.88a6.63 6.63 0 0 1-.06-1c.09.39.2.78.32 1.17l.16.09c-.17-.54-.32-1.07-.44-1.62l-.15.14a8 8 0 0 0 0 1.09zM542.25 339.69a.13.13 0 0 0-.11.05l.11-.05zM542.78 341q.18.8.39 1.59h.16c-.09-.31-.16-.61-.24-.92a3.87 3.87 0 0 0-.57-1.68h-.1c.2.15.33.82.36 1.01z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M548.19 344c0-.14.09-.29.13-.44a9.65 9.65 0 0 0 .35-1.16l-.26.13a10.92 10.92 0 0 1-.33 1.37c-.13.3-.26.61-.41.91a8.56 8.56 0 0 0 .3-1.31 4.68 4.68 0 0 0 .34-.93l-.17.07c0 .12-.07.25-.12.37v-.33l-.14.05a4.25 4.25 0 0 1 0 .8 6.18 6.18 0 0 1-.4.64c0-.44.09-.89.1-1.34h-.15c0 .52-.06 1-.12 1.54v.06a7.35 7.35 0 0 0-.24-1.17l.24-.39-.21.05-.1.16v-.13h-.13l.06.25c-.19.3-.4.58-.61.87-.11-.34-.23-.68-.37-1h-.07c.1.37.23.74.36 1.11l-.42.53c-.15-.3-.31-.6-.49-.89v-.19l.23-.54h-.16a1.57 1.57 0 0 1-.09.23v-.23H545v.48a5.92 5.92 0 0 0-.35-.48h-.11c.12.23.25.46.38.69l-.06.13-.36.72c-.09-.13-.19-.26-.29-.38l-.31-.42c0-.26.06-.52.08-.78h-.18v.59c-.11-.14-.21-.28-.32-.41a2.17 2.17 0 0 1-.07-.24h-.31c.08.12.16.25.25.37.1.33.21.66.34 1l-.09.37c0 .1-.06.2-.09.3a5.27 5.27 0 0 1-.83-1.15 4.76 4.76 0 0 1-.37-1.08h-.11a4.46 4.46 0 0 0 .41 1.16c-.14-.24-.27-.48-.39-.73s-.11-.33-.17-.49l-.18-.08a6.5 6.5 0 0 0 .55 1.31 9.38 9.38 0 0 0 .95 1.38c0 .11-.09.22-.14.33l-.1-.12q-.36-.46-.69-1v-.1c-.21-.31-.4-.64-.59-1s-.17-.7-.23-1l-.18-.11a5.81 5.81 0 0 0 .15.63c-.12-.24-.22-.5-.32-.75l-.15-.13a9.8 9.8 0 0 0 1.39 2.71c.1.36.22.72.35 1.07a3.85 3.85 0 0 0 0 .59 11.22 11.22 0 0 1-.09 1.53v.35c-.08.4-.3 1.56.26 1.15a.58.58 0 0 0 .3.24.46.46 0 0 0 .49-.15c.13.22.3.44.54.43a.46.46 0 0 0 .34-.25l.09-.13a.61.61 0 0 0 .86.15 1.13 1.13 0 0 0 .27-.3.71.71 0 0 0 .16.18c.33.24.48-.14.55-.4v-.1l.17.32c0 .06.11 0 .13 0a6.51 6.51 0 0 0 .08-1.71 7.84 7.84 0 0 1 .08-.82c0-.27.12-.54.19-.8a.75.75 0 0 0 .07-.12 9.33 9.33 0 0 0 .52-1.11v-.05c0-.05 0-.07.05-.1a10.69 10.69 0 0 0 1.3-2.65 1.08 1.08 0 0 1-.2.16 8 8 0 0 1-.83 1.71zm-1.31-.58v.11a8.85 8.85 0 0 1 .19 1c-.16.2-.33.4-.51.59 0-.1-.08-.2-.11-.3l-.21-.62c.24-.26.44-.54.64-.83zm-3.88 2.9l.21.48-.2.21c0-.2-.06-.4-.08-.61zm-.08 0a2.45 2.45 0 0 1 0-.27 1.34 1.34 0 0 0 .07.18zm.35.62l.21.44-.3.37c-.06-.2-.1-.39-.14-.59a2.39 2.39 0 0 0 .23-.28zm1.55-.41l-.2-.18c.08-.01.14.06.2.12zm-.1-.3l.07-.08.37.44-.07.07a5 5 0 0 0-.37-.49zm.21.58l-.41.4-.3-.38.32-.38zm-.34-.73c-.14-.14-.27-.28-.41-.41l.11-.2a6.3 6.3 0 0 0 .37.53zm-.1.11l-.08-.07c-.1-.1-.21-.2-.31-.31zm-.1.12l-.3.35-.3-.37a4 4 0 0 0 .22-.34c.12.05.25.18.38.3zm-.39.45l-.43.5c-.07-.14-.14-.28-.2-.42a5.2 5.2 0 0 0 .35-.44zm-.43.8l.23.43-.11.13-.27.36c-.07-.18-.13-.36-.19-.55zm.16 0l-.06-.12.47-.52c.1.12.2.24.29.37l-.53.57c-.06-.15-.12-.25-.17-.35zm.79-.16c.13.16.25.32.37.49l-.22.27-.35.43-.32-.59c.15-.26.33-.45.52-.65zm.09-.09l.26-.25c0-.06.11-.11.16-.16.13.12.25.24.37.37l-.43.52zm1.47-.52l.34-.38c.07.14.13.28.2.41-.09.14-.19.27-.28.4zm.13.6l-.1.12-.32-.39.16-.19zm-.25-.78l-.24-.37.42-.41.18.38zm-.11.14c-.07.07-.13.15-.19.22l-.31-.36.26-.25c.08.07.16.21.24.34zm-.27.31l-.09.11-.06-.06-.25-.36.07-.07zm-.05.35l.31.39-.11.12-.36.43-.06-.09-.25-.35zm.22.05l-.13-.15.09-.11.33.4-.09.11zm.37.25c.08.12.17.23.24.35l-.06.17-.27-.41zm.07-.09l.09-.11c.05.11.11.21.17.32v.1a3.46 3.46 0 0 0-.26-.36zm.22-.28l.28-.37v.05l-.18.56a.889.889 0 0 0-.1-.29zm.12-1.05l.22-.24c0 .13.08.25.13.38l-.16.24zm-.1-.2l-.18-.36.29-.3.13.4zm-.24-1.71l.18.54.12.37c-.1.11-.2.22-.31.32-.09-.18-.19-.35-.28-.52s-.07-.13-.1-.2zm-.44.7l.33.63-.44.42-.31-.44a.76.76 0 0 0-.08-.11c.15-.19.31-.38.46-.58h.04zm-.52-.88c.13.22.27.43.39.65l-.39.48c0-.43.01-.8 0-1.18zm0 1.56l.32.48-.16.15-.12.11c-.13-.15-.25-.3-.37-.46l.28-.35zm-.54-1l.41-.79v1.37l-.42-.56zm-.08.15l.46.63-.3.35-.38-.57zm-.65-.84c.08.09.15.19.23.29l.33.44c-.07.13-.13.26-.21.39a5.66 5.66 0 0 1-.4-.82c0-.16.01-.26.03-.37zm-.31-.39l.16.2v.16c-.1-.18-.14-.3-.18-.42zm.2.93c.08.18.17.36.26.53l.12.21c0 .07-.09.14-.13.22l-.41-.43a3.24 3.24 0 0 0 .14-.59zm-.21.66l.39.42-.37-.42zm-.58-.72c.14.19.29.38.44.56-.18-.22-.32-.42-.5-.62zm.51.91l.36.39-.21.32-.31-.39a3.18 3.18 0 0 0 .14-.38zm-.23.44l.3.38c-.1.14-.21.28-.32.41-.07-.16-.14-.32-.2-.48a3.46 3.46 0 0 0 .2-.37zm-.68-.89c.19.25.37.5.57.75l-.23.24c-.1-.33-.23-.69-.36-1zm.28 2.28a5.66 5.66 0 0 0 .15.59l-.23.3c-.01-.35.04-.65.06-.95zm-.19 1.48a1.77 1.77 0 0 0 .08.33c-.18-.17-.13-.21-.1-.39zm.27.39a1.55 1.55 0 0 1-.14-.51v-.3l.29-.3a9 9 0 0 0 .22.55c-.09.13-.17.26-.25.4s-.14.08-.14.1zm.1.12c.06-.09.1-.2.15-.28l.15-.24.21.41.1.2c-.16.07-.34.11-.63-.15zm.55-.31c-.06-.11-.11-.23-.16-.34l.31-.41.08-.1.33.62-.27.34-.13.18zm.64.59c-.3 0-.31 0-.4-.17l.06-.07.35-.44a5.14 5.14 0 0 0 .35.55c-.09.08-.09.08-.38.07zm.44-.26c-.09-.14-.16-.29-.22-.39l-.1-.16c.19-.24.39-.48.59-.71a1 1 0 0 0 .08.11l.23.33c-.14.17-.28.35-.41.54a2.61 2.61 0 0 0-.19.22zm1.08 0a.63.63 0 0 1-.8.29.65.65 0 0 1-.18-.16c.13-.21.26-.44.41-.64l.16-.2.26.4a2 2 0 0 1 .16.29zm.08-.14a4.93 4.93 0 0 1-.42-.66l.47-.58c.1.15.2.3.29.46-.08.21-.18.43-.27.64a.61.61 0 0 0-.09.1zm.66-.15c0 .11 0 .22-.07.33-.24.11-.4.1-.49 0a5.41 5.41 0 0 0 .33-.8l.24.43-.03.03zm0-.3l-.21-.36c0-.05 0-.1.05-.15l.17.31a1.49 1.49 0 0 1 .01.16zm0-.42l-.13-.24v-.08a2.12 2.12 0 0 0 .11.21.37.37 0 0 0 .08.07zm0-.56l.06-.17a2.11 2.11 0 0 0 0 .25.3.3 0 0 1-.01-.12zm.23 1.47c-.05-.11-.11-.21-.16-.31s0-.1 0-.16c0 .13.09.25.13.39zm0-.27c0-.15-.1-.28-.15-.42a.49.49 0 0 1 0-.12l.15.3a1.93 1.93 0 0 1 .09.2zm0-1.45v.91l-.14-.33c0-.27 0-.53.07-.79l.07.14s.1.01.1.03zm0-.32a.61.61 0 0 0 0-.12l.09-.36v.08c.11.08.11.24.04.36zm0-1l-.09-.26.19-.22c.1.15.1.32.04.47zm.11.34v-.11zm.07-1.18l-.35.36c0-.13-.09-.26-.13-.39.16-.18.33-.36.48-.54v.44a.59.59 0 0 0 .14.12zm.23.07v.06l-.05.09v-.11l.1-.1zm-.06-.25c.05-.26.09-.51.12-.76s.25-.37.37-.56c-.08.38-.19.75-.3 1.13z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M545.64 342.07c-.06.21-.13.43-.2.64h.15q.15-.45.27-.9a13.46 13.46 0 0 1 .37-1.52c0-.14.1-.28.16-.41s.12-.44.21-.1a3 3 0 0 1 0 .73 20.47 20.47 0 0 0 .06 2.08h.14c-.08-.89 0-1.81-.08-2.71a2.15 2.15 0 0 0 0-.23h-.41a3.4 3.4 0 0 0-.29.82c-.15.47-.24 1.04-.38 1.6zM547.27 342.46h.21l.06-.11a11.34 11.34 0 0 0 .57-1.16 5.42 5.42 0 0 1 .44-1 8.09 8.09 0 0 1-.26 2l.14-.07a7.81 7.81 0 0 0 .24-1.88l-.24-.12a13.74 13.74 0 0 0-.84 1.83c-.1.14-.21.33-.32.51zM548.67 340.07a.13.13 0 0 0 .1-.14.15.15 0 0 0-.15-.15.16.16 0 0 0-.15.16.09.09 0 0 0 0 .05l-.05.07.24.12zM544.51 339.45a.09.09 0 0 0 0-.05.18.18 0 0 0-.35 0 .14.14 0 0 0 0 .07.44.44 0 0 0-.08.11h.52a.47.47 0 0 0-.09-.13zM546.88 339.46a.15.15 0 0 0 0-.13.19.19 0 0 0-.21-.1.17.17 0 0 0-.11.11.28.28 0 0 0 0 .09l-.08.1.44.05a.34.34 0 0 0-.04-.12zM542.19 340v.14h.09v-.07a.11.11 0 0 1 .12 0h.1l-.13-.12a.14.14 0 0 0-.14-.16l-.11.05a.15.15 0 0 0 .07.16zM541.48 340.52a.19.19 0 0 0 0-.08.14.14 0 0 0-.15-.13.14.14 0 0 0-.14.14.16.16 0 0 0 .14.14.49.49 0 0 1 0 .12z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M542.3 340v.07l.16-.07a.11.11 0 0 0-.16 0z'
        style={{
          fill: 'url(#s-2f2b1ca8ca-aL)',
        }}
        transform='translate(-233.63 -274.8)'
      />
      <path
        d='M545.18 339.17a9 9 0 0 0-2.93.52.14.14 0 0 1 .14.16l.13.12a7.35 7.35 0 0 1 1.62-.36.31.31 0 0 1 .08-.11.14.14 0 0 1 0-.06.15.15 0 0 1 .15-.16.16.16 0 0 1 .17.15.44.44 0 0 1 .11.09 5.17 5.17 0 0 1 .57 0 8.45 8.45 0 0 1 1.14 0l.07-.1a.22.22 0 0 1 0-.08.14.14 0 0 1 .1-.1.14.14 0 0 1 .18.08.15.15 0 0 1 0 .13.43.43 0 0 1 0 .12 6.05 6.05 0 0 1 1.69.45l.05-.07a.09.09 0 0 1 0-.05.16.16 0 0 1 .15-.16.15.15 0 0 1 .15.15.13.13 0 0 1-.1.14v.11c.45.25.71.55.72.85s-.34.72-1 1l-.14.07a6.35 6.35 0 0 1-.81.28h-.21a2.72 2.72 0 0 1-.43.09h-.14a9.2 9.2 0 0 1-1.11.12h-1.64l-.58-.09h-.16a6.35 6.35 0 0 1-.92-.26h-.1l-.23-.1-.16-.09a1.67 1.67 0 0 1-.26-.17l-.16-.13a.84.84 0 0 1-.28-.53.8.8 0 0 1 .27-.56.49.49 0 0 0 0-.12.16.16 0 0 1-.14-.14.14.14 0 0 1 .14-.14.14.14 0 0 1 .15.13.19.19 0 0 1 0 .08 3.59 3.59 0 0 1 .69-.41v-.14a.15.15 0 0 1-.05-.23c-.9.38-1.46.9-1.44 1.49a1.1 1.1 0 0 0 .38.77l.15.13.17.12.18.11.31.15.18.08.15.06h.11a7.52 7.52 0 0 0 .79.21h.31a3.32 3.32 0 0 0 .44.06H545.8a8.58 8.58 0 0 0 .92-.11h.25l.21-.05h.32l.35-.1.14-.05h.12l.17-.07h.1l.26-.13a3 3 0 0 0 .4-.25 1.08 1.08 0 0 0 .2-.16 1.17 1.17 0 0 0 .47-.9c.02-1.09-1.99-1.9-4.53-1.84z'
        style={{
          fill: 'url(#s-2f2b1ca8ca-aM)',
        }}
        transform='translate(-233.63 -274.8)'
      />
    </g>
    <g
      id='unihockey'
    >
      <g
        id='unihockeyRight'
      >
        <path
          d='M485.32 172.68l-50.84-3.3-4.08-32.27 45.55 2.71 9.37 32.86z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M473.35 164.61l10.95.63v-1l-6.54-19.46-9.71.21v1l8.5.48 5.45 17.04-8.65.1v1z'
          style={{
            fill: 'url(#s-2f2b1ca8ca-e)',
          }}
        />
        <path
          d='M473.37 163.61l10.93.63-6.54-19.46-10.16-.47.53.68 9.02.51 5.87 18.07-9.86-.57.21.61z'
          style={{
            fill: 'url(#s-2f2b1ca8ca-aN)',
          }}
        />
        <path
          d='M710.92 420.58c-1 0-2.07 0-3.28-.13v-.1a36.11 36.11 0 0 0 7-.08v.1a34.21 34.21 0 0 1-3.72.21zM710.87 420.06c-1 0-2-.05-3.19-.14v-.1a33.3 33.3 0 0 0 6.73-.07v.1a31.81 31.81 0 0 1-3.54.21zM710.91 421.63c-1.06 0-2.17 0-3.36-.13v-.1a38.85 38.85 0 0 0 7.27-.08v.1a36.35 36.35 0 0 1-3.91.21zM710.91 421.11c-1 0-2.13-.05-3.32-.14v-.09a38.32 38.32 0 0 0 7.14-.08v.1a35.16 35.16 0 0 1-3.82.21zM711.08 422.6c-1.11 0-2.28-.05-3.62-.15v-.1a40.73 40.73 0 0 0 7.43 0v.09c-1.31.09-2.52.16-3.81.16zM710.91 422.06c-1.09 0-2.21-.05-3.4-.13v-.1a40.71 40.71 0 0 0 7.36-.08v.1a36.92 36.92 0 0 1-3.96.21zM711.12 423.65c-1.18 0-2.41 0-3.75-.14v-.1a44.28 44.28 0 0 0 7.75-.05v.1c-1.32.13-2.63.19-4 .19zM711.23 423.13c-1.18 0-2.42-.05-3.81-.15v-.1a42.75 42.75 0 0 0 7.62 0v.1a37.35 37.35 0 0 1-3.81.15zM711.12 424.7c-1.24 0-2.52 0-3.84-.14v-.1a47.19 47.19 0 0 0 8 0v.1c-1.28.08-2.71.14-4.16.14zM710.65 424.16c-1.1 0-2.2 0-3.32-.13v-.1a45 45 0 0 0 7.87-.1v.1c-1.56.15-3.06.23-4.55.23zM711.5 425.79c-1.33 0-2.71-.06-4.31-.18v-.1a50.24 50.24 0 0 0 8.23 0v.1c-1.35.12-2.61.18-3.92.18zM711.12 425.23c-1.27 0-2.57-.05-3.88-.14V425a48.69 48.69 0 0 0 8.13-.06v.1c-1.37.12-2.76.19-4.25.19zM711.54 426.74c-1.4 0-2.85-.06-4.43-.17v-.1a54.61 54.61 0 0 0 8.49 0v.1c-1.35.11-2.68.17-4.06.17zM711.52 426.21c-1.35 0-2.76-.06-4.37-.17v-.1a50.65 50.65 0 0 0 8.36 0v.1c-1.35.12-2.64.17-3.99.17zM710.59 427.75c-1.11 0-2.31 0-3.57-.13v-.1a56.44 56.44 0 0 0 8.73-.1v.09c-1.42.12-3.16.24-5.16.24zM711.56 427.26c-1.43 0-2.91-.05-4.5-.17V427a55 55 0 0 0 8.61 0v.1c-1.34.11-2.67.16-4.11.16zM710.87 428.28c-1.32 0-2.61 0-3.9-.13v-.1a57.08 57.08 0 0 0 8.85-.08v.1c-1.69.14-3.34.21-4.95.21zM711.63 429.37c-1.55 0-3.16-.06-4.75-.17v-.1a60.15 60.15 0 0 0 9.11 0v.1c-1.34.11-2.82.17-4.36.17zM710.93 428.81c-1.36 0-2.7 0-4-.14v-.1a58.65 58.65 0 0 0 9-.06v.1c-1.69.13-3.36.2-5 .2zM712.11 430.46c-1.66 0-3.38-.07-5.32-.21v-.1a65.69 65.69 0 0 0 9.38.07v.1c-1.37.09-2.69.14-4.06.14zM712.05 429.93c-1.61 0-3.27-.07-5.22-.2v-.1a62 62 0 0 0 9.22.06v.1c-1.38.1-2.67.14-4 .14zM712.18 431.51c-1.74 0-3.54-.07-5.49-.2v-.1a69.37 69.37 0 0 0 9.64.07v.1c-1.33.09-2.73.13-4.15.13zM712.14 431c-1.7 0-3.46-.07-5.4-.21v-.1a67.51 67.51 0 0 0 9.51.07v.1c-1.36.08-2.71.14-4.11.14zM712.42 432.47c-1.66 0-3.38-.07-5.32-.21v-.1a65.55 65.55 0 0 0 9.37.07v.1c-1.36.09-2.69.14-4.05.14zM712.52 432c-1.81 0-3.73-.08-5.86-.23v-.1a68.44 68.44 0 0 0 9.75.1v.1c-1.25.05-2.54.13-3.89.13zM713 433.55c-1.73 0-3.59-.07-5.81-.23v-.1a66.17 66.17 0 0 0 9.46.11v.1c-1.25.08-2.44.12-3.65.12zM711.7 433c-1.51 0-3-.06-4.6-.18v-.09a66.11 66.11 0 0 0 9.44 0v.1c-1.74.07-3.3.17-4.84.17zM713 434.62c-1.68 0-3.36-.08-5.66-.24v-.1a67.74 67.74 0 0 0 9.49.12v.1c-1.44.08-2.64.12-3.83.12zM712.91 434.09c-1.65 0-3.29-.08-5.59-.24v-.1a64.86 64.86 0 0 0 9.39.12v.1c-1.43.08-2.61.12-3.8.12zM712.45 435.7c-1.56 0-3.21-.06-5.27-.21v-.1a68.46 68.46 0 0 0 9.78.07v.1c-1.61.08-3.02.14-4.51.14zM713 435.14c-1.73 0-3.49-.08-5.79-.24v-.1a68.42 68.42 0 0 0 9.64.13v.1c-1.36.07-2.58.11-3.85.11zM712.53 436.65c-1.62 0-3.34-.06-5.43-.21v-.1a71.76 71.76 0 0 0 10 .07v.1c-1.57.09-3.02.14-4.57.14zM712.49 436.12c-1.59 0-3.27-.06-5.34-.2v-.1a71.44 71.44 0 0 0 9.89.06v.1c-1.61.09-3.04.14-4.55.14zM713.09 437.73c-1.92 0-3.86-.08-6.08-.23v-.1a77.09 77.09 0 0 0 10.27.11v.1c-1.44.08-2.81.12-4.19.12zM713 437.2c-1.86 0-3.73-.08-5.91-.23v-.1a75.2 75.2 0 0 0 10.15.11v.1c-1.52.08-2.9.12-4.24.12z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M482.83 163.86l-2.3-19.23.1-.02 2.3 19.23-.1.02z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M714.49 419.23h.1v19.56h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-5.8 -2115.022 2597.29)'
        />
        <path
          d='M474.34 163.41h-.1l.08-19.18h.1l-.08 19.18zM475 163.39h-.1l.09-19.08h.1l-.09 19.08zM475.73 163.52h-.1l.14-19.21h.1l-.14 19.21z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M711.95 419.19h.1v19.19h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-1.57 -9432.354 8816.956)'
        />
        <path
          d='M476.6 144.31h.1v19.28h-.1z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M712.66 419.21h.1v19.33h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-2.39 -5990.11 5891.89)'
        />
        <path
          d='M713.62 419.23h.1v19.48h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-4.12 -3223.378 3538.978)'
        />
        <path
          d='M711.07 419.11h.1v19.3h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.81 -18845.305 16815.586)'
        />
        <path
          d='M704.49 402c-.71 0-1.44 0-2.26-.08v-.1a29.16 29.16 0 0 0 6.2-.21v.1a27.77 27.77 0 0 1-3.94.29zM704.5 401.46c-.68 0-1.41 0-2.24-.08v-.1a26.22 26.22 0 0 0 6-.21v.1a24.21 24.21 0 0 1-3.76.29zM704.42 403c-.72 0-1.46 0-2.25-.07v-.1a30.61 30.61 0 0 0 6.43-.23v.1a28.94 28.94 0 0 1-4.18.3zM704.44 402.5c-.71 0-1.45 0-2.24-.07v-.1a30.15 30.15 0 0 0 6.31-.23v.1a27.87 27.87 0 0 1-4.07.3zM704.6 404c-.77 0-1.59 0-2.49-.08v-.1a32 32 0 0 0 6.57-.2v.1a30 30 0 0 1-4.08.28zM704.4 403.44c-.73 0-1.47 0-2.26-.07v-.1a32.19 32.19 0 0 0 6.52-.23v.1a29.75 29.75 0 0 1-4.26.3zM704.56 405c-.8 0-1.63 0-2.51-.08v-.1a34.82 34.82 0 0 0 6.85-.2v.09a31.45 31.45 0 0 1-4.34.29zM704.67 404.49c-.81 0-1.66 0-2.59-.08v-.1a34.35 34.35 0 0 0 6.75-.19v.1a31.57 31.57 0 0 1-4.16.27zM704.48 406.05c-.81 0-1.64 0-2.49-.08v-.09a38 38 0 0 0 7.08-.22v.1a35.52 35.52 0 0 1-4.59.29zM704.16 405.52c-.71 0-1.42 0-2.14-.07v-.1a35.4 35.4 0 0 0 7-.26v.1a36.57 36.57 0 0 1-4.86.33zM704.88 407.11c-.92 0-1.88 0-3-.09v-.1a39.61 39.61 0 0 0 7.3-.17v.1a35.66 35.66 0 0 1-4.3.26zM704.46 406.57c-.82 0-1.66 0-2.5-.07v-.1a39.3 39.3 0 0 0 7.2-.22v.1a36.88 36.88 0 0 1-4.7.29zM704.83 408.05c-.94 0-1.92 0-3-.09v-.1a41.94 41.94 0 0 0 7.51-.17v.1a40.24 40.24 0 0 1-4.51.26zM704.87 407.53c-.93 0-1.9 0-3-.09v-.1a40.71 40.71 0 0 0 7.4-.17v.1a36.77 36.77 0 0 1-4.4.26zM704 409.07c-.71 0-1.46 0-2.23-.07v-.1a43.57 43.57 0 0 0 7.72-.28v.1a47.1 47.1 0 0 1-5.49.35zM704.82 408.57c-1 0-1.94 0-3-.09v-.1a43.19 43.19 0 0 0 7.62-.17v.1a41.44 41.44 0 0 1-4.62.26zM704.23 409.59c-.83 0-1.64 0-2.45-.07v-.1a44.27 44.27 0 0 0 7.84-.25v.1a45.8 45.8 0 0 1-5.39.32zM704.74 410.65c-1 0-2 0-3-.08v-.1a49.66 49.66 0 0 0 8.08-.18v.1a47.16 47.16 0 0 1-5.08.26zM704.24 410.12c-.84 0-1.67 0-2.49-.07V410a47.39 47.39 0 0 0 8-.25v.1a48.62 48.62 0 0 1-5.51.27zM705.23 411.72c-1.12 0-2.29 0-3.58-.11v-.1a51.59 51.59 0 0 0 8.31-.12v.1c-1.58.15-3.1.23-4.73.23zM705.24 411.2c-1.1 0-2.25 0-3.55-.11V411a49.86 49.86 0 0 0 8.17-.12v.1c-1.6.14-3.05.22-4.62.22zM705.22 412.76c-1.16 0-2.36 0-3.63-.11v-.1a54.38 54.38 0 0 0 8.53-.12v.1c-1.59.15-3.2.23-4.9.23zM705.22 412.24c-1.14 0-2.32 0-3.6-.11V412a53 53 0 0 0 8.42-.12v.1c-1.58.18-3.15.26-4.82.26zM705.22 413.7c-1.18 0-2.41 0-3.68-.1v-.1a58.35 58.35 0 0 0 8.74-.13v.1c-1.62.15-3.28.23-5.06.23zM705.51 413.19c-1.23 0-2.54 0-3.94-.12V413a55.37 55.37 0 0 0 8.63-.09v.1c-1.48.11-3.02.18-4.69.18zM705.68 414.76c-1.32 0-2.73 0-4.2-.12v-.1a59 59 0 0 0 8.93-.09v.1c-1.41.14-3.01.21-4.73.21zM704.54 414.2c-1 0-2 0-3-.08V414a57.26 57.26 0 0 0 8.83-.21v.1c-2.02.21-3.94.31-5.83.31zM705.69 415.81c-1.33 0-2.72 0-4.28-.13v-.1a62 62 0 0 0 9.19-.08v.1c-1.67.14-3.24.21-4.91.21zM705.68 415.29c-1.31 0-2.68 0-4.24-.13v-.1a60.2 60.2 0 0 0 9.06-.08v.1c-1.66.14-3.19.21-4.82.21zM705.7 416.85c-1.38 0-2.8 0-4.35-.13v-.1a65 65 0 0 0 9.41-.08v.1c-1.67.14-3.32.21-5.06.21zM705.69 416.33c-1.35 0-2.76 0-4.31-.13v-.1a63.45 63.45 0 0 0 9.3-.08v.1c-1.68.14-3.28.21-4.99.21zM705.7 417.79c-1.42 0-2.88 0-4.4-.12v-.1a69.38 69.38 0 0 0 9.62-.09v.1a62.7 62.7 0 0 1-5.22.21zM705.7 417.27c-1.4 0-2.84 0-4.37-.12v-.1a67.79 67.79 0 0 0 9.51-.09v.1c-1.68.14-3.37.21-5.14.21zM706.21 418.86q-2.34 0-5-.15v-.1a72.61 72.61 0 0 0 9.85 0v.1c-1.45.08-3.06.15-4.85.15zM706.14 418.33c-1.53 0-3.14-.05-4.88-.14v-.1a70.75 70.75 0 0 0 9.73 0v.1c-1.5.08-3.11.14-4.85.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M709.17 400.68h.1v19.11h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-7.17 -1600.576 2137.375)'
        />
        <path
          d='M708.45 400.57h.1v19.31h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-6.26 -1921.515 2408.765)'
        />
        <path
          d='M468.87 144.8l-.03-19.11h.1l.02 19.11h-.09z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M703.17 400.59h.1v18.95h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.13 -120504.486 103251.411)'
        />
        <path
          d='M703.93 400.59h.1v18.94h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.31 -50212.772 43446.131)'
        />
        <path
          d='M472.98 144.72l-.82-18.94h.1l.82 18.94h-.1z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M704.73 400.59h.1v18.99h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.75 -20404.937 18119.877)'
        />
        <path
          d='M706.83 400.58h.1v19.1h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-3.2 -4329.084 4454.734)'
        />
        <path
          d='M707.68 400.58h.1v19.24h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-4.75 -2722.307 3089.069)'
        />
        <path
          d='M705.48 400.49h.1v19.09h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-1.41 -10578.307 9765.121)'
        />
        <path
          d='M710.8 419.94l-2.2-18.13c-.07-.79-.94-.93-1.66-.91l-6-.2v-.57l6 .2c1.88-.05 2.18 1 2.22 1.42l2.19 18.12z'
          style={{
            fill: 'url(#s-2f2b1ca8ca-aO)',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M711.5 421.27l-2.19-18.13a1.32 1.32 0 0 0-1.24-1.19l-6-.2v-.1l6 .2a1.43 1.43 0 0 1 1.34 1.28l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M712 422.55l-2.2-18.13a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M712.47 424.16l-2.2-18.16a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.2 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M712.92 425.31l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.27L713 425.3z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M713.38 426.65l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2V407l6 .2a1.42 1.42 0 0 1 1.34 1.27l2.19 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M713.85 428l-2.2-18.13a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.2 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M714.35 429.61l-2.19-18.13a1.33 1.33 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.43 1.43 0 0 1 1.34 1.28l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M714.84 431l-2.2-18.14a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.33 1.27l2.2 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M715.31 432.46l-2.19-18.13a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M715.79 433.9l-2.19-18.13a1.31 1.31 0 0 0-1.25-1.19l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.27l2.19 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M716.3 435.64l-2.2-18.13a1.31 1.31 0 0 0-1.24-1.19l-6-.19V416l6 .19a1.42 1.42 0 0 1 1.33 1.28l2.2 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M716.77 437l-2.2-18.13a1.31 1.31 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.42 1.42 0 0 1 1.33 1.28l2.2 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M717 438.58l-2.19-18.14a1.07 1.07 0 0 0-1-1l-6.38-.2v-.57l6.38.19a1.67 1.67 0 0 1 1.57 1.49l2.19 18.13z'
          style={{
            fill: 'url(#s-2f2b1ca8ca-aP)',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M705.43 399.95h.1v19.33h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-17.86 -285.924 1015.549)'
        />
        <path
          d='M706.59 400.06h.1v19.37h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-17.47 -304.457 1032.612)'
        />
        <path
          d='M476.94 144.32l-5.71-18.56.1-.03 5.71 18.57-.1.02zM478.23 144.33l-6.09-18.62.1-.03 6.09 18.61-.1.04zM479.3 144.33l-6.31-18.52.09-.03 6.31 18.51-.09.04z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M710.88 400.21h.1v19.52h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-18.69 -240.66 982.466)'
        />
        <path
          d='M707.19 439.61a.57.57 0 0 1-.57-.57v-20.11l-4.72-14.73v16.46a.58.58 0 0 1-.57.57.57.57 0 0 1-.57-.57v-20.12a.57.57 0 0 1 1.11-.17l5.83 18.21a.48.48 0 0 1 .06.24V439a.58.58 0 0 1-.57.61z'
          style={{
            fill: 'url(#s-2f2b1ca8ca-aQ)',
          }}
          transform='translate(-233.63 -274.8)'
        />
      </g>
      <g
        id='unihockeyLeft'
      >
        <path
          d='M141.24 149.87l-44.43-2.59 41.57-26.27 40.87 2.72-38.01 26.14z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M354.29 415.06l-11.91-.75v-1.09l20.85-12.45a3.17 3.17 0 0 1 2-.41l9.5 1.3v1.09l-9.22-.58a3.1 3.1 0 0 0-1.81.45L347 412.74l7.26 1.23z'
          style={{
            fill: 'url(#s-2f2b1ca8ca-aR)',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M354.14 414l-11.76-.74 21-12.51a3.11 3.11 0 0 1 1.79-.43l10.11.64-.45.58a.4.4 0 0 1-.33.15l-9.14-.58a3.13 3.13 0 0 0-1.79.43l-18.6 11.1 10.39.66-.93.64a.36.36 0 0 1-.29.06z'
          style={{
            fill: 'url(#s-2f2b1ca8ca-aS)',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M374.06 381.56a26 26 0 0 1-5.78-.58v-.11a26.75 26.75 0 0 0 6.24.58v.11zM374 381a23.66 23.66 0 0 1-5.49-.56v-.11a24.6 24.6 0 0 0 6 .56v.1zM374.11 382.72a28.37 28.37 0 0 1-6.06-.6v-.11a28.19 28.19 0 0 0 6.47.6v.11zM374.1 382.14a27.32 27.32 0 0 1-5.94-.59v-.11a27.7 27.7 0 0 0 6.35.59v.11zM374 383.77a29.24 29.24 0 0 1-6.14-.58v-.11a29.41 29.41 0 0 0 6.62.58v.11zM374.13 383.19a29.34 29.34 0 0 1-6.17-.61v-.11a29.56 29.56 0 0 0 6.56.61v.11zM374.08 384.94a31.43 31.43 0 0 1-6.46-.61v-.11a32 32 0 0 0 6.9.6v.11zM374 384.35a30.24 30.24 0 0 1-6.31-.58v-.11a30.43 30.43 0 0 0 6.79.58v.11zM374.13 386.1a34 34 0 0 1-6.74-.63v-.1a35.42 35.42 0 0 0 7.12.62v.11zM374.19 385.52a33 33 0 0 1-6.67-.68v-.11a32.7 32.7 0 0 0 7 .68v.1zM374 387.26a35.75 35.75 0 0 1-6.8-.58v-.11a36.79 36.79 0 0 0 7.34.58v.11zM374.14 386.68a35.15 35.15 0 0 1-6.86-.64v-.1a36 36 0 0 0 7.24.63v.11zM374 388.31a38.72 38.72 0 0 1-7.09-.6v-.1a39.22 39.22 0 0 0 7.57.59v.11zM374 387.73a37.06 37.06 0 0 1-6.93-.59v-.11a37.09 37.09 0 0 0 7.45.59v.11zM374.23 389.47a41.6 41.6 0 0 1-7.48-.73v-.11a40.15 40.15 0 0 0 7.77.73v.11zM374.05 388.89a39.91 39.91 0 0 1-7.21-.6v-.11a39.5 39.5 0 0 0 7.68.6v.11zM374.19 390.06a42.5 42.5 0 0 1-7.56-.71v-.11a41.69 41.69 0 0 0 7.89.71v.1zM374.12 391.22a45.44 45.44 0 0 1-7.73-.64v-.11a45.14 45.14 0 0 0 8.13.64v.11zM374.2 390.64a43.3 43.3 0 0 1-7.68-.71v-.11a43.31 43.31 0 0 0 8 .71v.11zM374 392.38a46.94 46.94 0 0 1-7.81-.59v-.11a47.73 47.73 0 0 0 8.37.59v.11zM373.91 391.8a44.79 44.79 0 0 1-7.61-.58v-.11a45.3 45.3 0 0 0 8.23.58v.11zM374 393.55a49.76 49.76 0 0 1-8.07-.61v-.11a49.37 49.37 0 0 0 8.59.6v.11zM374 393a47.19 47.19 0 0 1-7.94-.6v-.1a49.1 49.1 0 0 0 8.48.59v.11zM374 394.6a51.24 51.24 0 0 1-8.29-.63v-.1a52.76 52.76 0 0 0 8.8.62v.1zM373.92 394a49.24 49.24 0 0 1-8.09-.59v-.1a50.79 50.79 0 0 0 8.69.57v.12zM373.91 395.76a54 54 0 0 1-8.38-.58v-.11a54.44 54.44 0 0 0 9 .58v.11zM374.15 395.18a52.78 52.78 0 0 1-8.52-.72v-.1a52.84 52.84 0 0 0 8.89.71v.11zM373.86 396.92a55.69 55.69 0 0 1-8.6-.59v-.11a56.05 56.05 0 0 0 9.26.59v.11zM373.85 396.34a55.13 55.13 0 0 1-8.46-.58v-.11a55.5 55.5 0 0 0 9.13.58v.11zM373.91 398.09a58.77 58.77 0 0 1-8.87-.61v-.11a60.06 60.06 0 0 0 9.49.6v.11zM373.89 397.5a58.59 58.59 0 0 1-8.74-.59v-.11a58.56 58.56 0 0 0 9.37.59v.11zM374 399.14a63.37 63.37 0 0 1-9.12-.62v-.11a63.84 63.84 0 0 0 9.69.62v.1zM373.93 398.55a60.08 60.08 0 0 1-9-.61v-.1a61.31 61.31 0 0 0 9.58.6v.11zM373.85 400.3a65.9 65.9 0 0 1-9.25-.58v-.11a66.45 66.45 0 0 0 9.93.58v.11zM373.85 399.72a63.49 63.49 0 0 1-9.14-.58v-.11a66.53 66.53 0 0 0 9.81.58v.11z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M131.7 125.88l-.11-.02 3.93-20.78.1.02-3.92 20.78zM132.59 125.88l-.11-.02 3.75-20.85.11.02-3.75 20.85zM139.6 126.42h-.11l.16-21.25h.1l-.15 21.25z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M361.99 390.46h21.2v.11h-21.2z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-89.4 116.553 371.078)'
        />
        <path
          d='M138.1 126.26h-.11l.44-21.1.1.01-.43 21.09zM135.45 126.11l-.1-.01 2.27-21.08.11.01-2.28 21.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M360.93 390.38h21v.11h-21z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-88.08 112.534 373.834)'
        />
        <path
          d='M359.02 390.25h21.11v.11h-21.11z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-82.95 97.352 385.054)'
        />
        <path
          d='M358.25 390.21h21.04v.11h-21.04z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-81.33 91.995 388.841)'
        />
        <path
          d='M136.52 126.11l-.11-.01 1.45-21.08.11.01-1.45 21.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M364.71 400.73l-.61-.12 3.9-19.75a1.69 1.69 0 0 1 1.74-1.35l5.34.32v.62l-5.34-.32a1.07 1.07 0 0 0-1.1.85z'
          style={{
            fill: 'url(#s-2f2b1ca8ca-aT)',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M349.81 386.1h24.01v.08h-24.01z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.96 -251.062 670.556)'
        />
        <path
          d='M346.42 386.07h24.47v.08h-24.47z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.58 -260.755 675.99)'
        />
        <path
          d='M117.17 117.39l-.04-.07 20.53-12.33.04.07-20.53 12.33zM116.48 117.27l-.04-.07 20.27-12.17.04.06-20.27 12.18zM115.5 117.39l-.04-.07 20.6-12.33.04.07-20.6 12.33z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M370.29 378.64h.08v3.27h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-86.86 108.392 366.274)'
        />
        <path
          d='M369.4 379.41h.08v2.79h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.7 88.018 383.368)'
        />
        <path
          d='M136.44 106.74l-2.55-.63.02-.07 2.55.63-.02.07z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M368.14 380.39h.08v2.35h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-68.96 51.298 414.26)'
        />
        <path
          d='M367.52 380.76h.08v2.35h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-68.46 48.81 416.228)'
        />
        <path
          d='M351.56 389.59h.08v4.01h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-86 87.726 378.886)'
        />
        <path
          d='M352.32 389.27h.08v3.47h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-84.68 84.728 381.797)'
        />
        <path
          d='M353.23 388.85h.08v3.21h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-81.67 77.458 388.222)'
        />
        <path
          d='M354.06 388.41h.08v3.11h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.3 74.391 391.038)'
        />
        <path
          d='M129.74 110.79l-3.04-.43.01-.07 3.04.43-.01.07zM130.63 110.25l-3.01-.43.01-.08 3.02.43-.02.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M355.02 387.84h.08v3.09h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.34 75.505 390.37)'
        />
        <path
          d='M355.84 387.44h.08v2.94h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78 69.372 395.757)'
        />
        <path
          d='M356.65 386.9h.08v3.04h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.6 77.466 392.952)'
        />
        <path
          d='M357.47 386.47h.08v2.91h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78 71.02 394.781)'
        />
        <path
          d='M126.04 113.02l-2.88-.58.02-.07 2.88.58-.02.07z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M359.1 385.44h.08v3.03h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.59 80.264 387.323)'
        />
        <path
          d='M366.36 381.04h.08v3.2h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.2 85.939 386.05)'
        />
        <path
          d='M134.54 107.88l-2.44-.71.02-.07 2.44.71-.02.07zM133.44 108.55l-2.76-.54.02-.08 2.76.55-.02.07z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M364.91 382.08h.08v2.77h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.21 82.095 387.242)'
        />
        <path
          d='M364.21 382.51h.08v2.8h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.13 78.181 390.429)'
        />
        <path
          d='M363.54 382.91h.08v2.79h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-77.77 76.397 391.754)'
        />
        <path
          d='M361.16 384.26h.08v2.94h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.64 79.596 388.435)'
        />
        <path
          d='M128.21 111.71l-2.83-.57.01-.08 2.84.57-.02.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M359.83 385.15h.08v2.76h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-75.78 66.524 399.235)'
        />
        <path
          d='M342.04 405.82h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -262.881 693.679)'
        />
        <path
          d='M342.07 405.24h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -262.84 693.103)'
        />
        <path
          d='M342.22 404.62h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -262.694 692.497)'
        />
        <path
          d='M342.41 404.08h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -262.502 691.943)'
        />
        <path
          d='M342.44 403.49h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -262.48 691.362)'
        />
        <path
          d='M342.59 402.88h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -262.328 690.738)'
        />
        <path
          d='M342.65 402.38h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -262.253 690.25)'
        />
        <path
          d='M342.87 401.86h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -262.048 689.718)'
        />
        <path
          d='M342.9 401.27h24.27v.11H342.9z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -262.007 689.142)'
        />
        <path
          d='M343.05 400.66h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -261.86 688.537)'
        />
        <path
          d='M343.24 400.11h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -261.67 687.982)'
        />
        <path
          d='M343.27 399.53h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -261.646 687.401)'
        />
        <path
          d='M343.42 398.92h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -261.495 686.777)'
        />
        <path
          d='M343.48 398.42h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -261.437 686.284)'
        />
        <path
          d='M343.58 397.85h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -261.324 685.728)'
        />
        <path
          d='M343.61 397.27h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -261.301 685.147)'
        />
        <path
          d='M343.77 396.65h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -261.15 684.523)'
        />
        <path
          d='M343.95 396.11h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -260.963 683.987)'
        />
        <path
          d='M343.98 395.53h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -260.94 683.406)'
        />
        <path
          d='M344.13 394.91h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -260.77 682.787)'
        />
        <path
          d='M344.2 394.41h24.27v.11H344.2z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -260.713 682.294)'
        />
        <path
          d='M344.37 393.74h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -260.547 681.616)'
        />
        <path
          d='M344.53 393.12h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -260.377 680.997)'
        />
        <path
          d='M344.71 392.58h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -260.208 680.456)'
        />
        <path
          d='M344.74 392h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -260.168 679.88)'
        />
        <path
          d='M344.9 391.38h24.27v.11H344.9z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -260.016 679.256)'
        />
        <path
          d='M344.96 390.88h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -259.959 678.762)'
        />
        <path
          d='M345.06 390.32h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -259.858 678.183)'
        />
        <path
          d='M345.09 389.74h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -259.817 677.607)'
        />
        <path
          d='M345.24 389.12h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -259.67 677.001)'
        />
        <path
          d='M345.42 388.58h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -259.48 676.447)'
        />
        <path
          d='M345.45 387.99h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -259.457 675.866)'
        />
        <path
          d='M345.61 387.38h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -259.305 675.242)'
        />
        <path
          d='M345.67 386.88h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -259.248 674.749)'
        />
        <path
          d='M336.16 402.19h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 62.236 407.188)'
        />
        <path
          d='M337.33 401.47h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 63.402 406.463)'
        />
        <path
          d='M336.73 401.86h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 62.808 406.852)'
        />
        <path
          d='M337.84 401.19h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 63.918 406.183)'
        />
        <path
          d='M339.01 400.47h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 65.084 405.457)'
        />
        <path
          d='M338.41 400.85h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 64.49 405.846)'
        />
        <path
          d='M339.52 400.19h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.5 66.846 406.2)'
        />
        <path
          d='M340.69 399.47h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 66.76 404.458)'
        />
        <path
          d='M340.09 399.85h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 66.166 404.847)'
        />
        <path
          d='M341.2 399.18h20.58v.11H341.2z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 67.276 404.178)'
        />
        <path
          d='M342.37 398.46h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 68.449 403.457)'
        />
        <path
          d='M341.78 398.85h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 67.848 403.841)'
        />
        <path
          d='M342.89 398.24h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 68.959 403.233)'
        />
        <path
          d='M344.06 397.52h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 70.13 402.513)'
        />
        <path
          d='M343.46 397.9h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 69.541 402.896)'
        />
        <path
          d='M344.57 397.23h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 70.646 402.233)'
        />
        <path
          d='M345.74 396.51h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 71.813 401.507)'
        />
        <path
          d='M345.14 396.9h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 71.223 401.89)'
        />
        <path
          d='M346.26 396.24h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 72.33 401.238)'
        />
        <path
          d='M347.43 395.52h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 73.502 400.518)'
        />
        <path
          d='M346.83 395.91h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 72.901 400.902)'
        />
        <path
          d='M347.94 395.24h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 74.017 400.238)'
        />
        <path
          d='M349.11 394.52h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 75.183 399.512)'
        />
        <path
          d='M348.51 394.9h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 74.589 399.901)'
        />
        <path
          d='M349.62 394.24h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 75.694 399.238)'
        />
        <path
          d='M350.79 393.52h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 76.86 398.513)'
        />
        <path
          d='M350.19 393.9h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 76.27 398.896)'
        />
        <path
          d='M351.3 393.23h20.58v.11H351.3z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.5 78.644 399.199)'
        />
        <path
          d='M352.47 392.51h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 78.542 397.507)'
        />
        <path
          d='M351.88 392.9h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 77.952 397.89)'
        />
        <path
          d='M352.99 392.29h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 79.063 397.282)'
        />
        <path
          d='M354.16 391.57h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 80.235 396.562)'
        />
        <path
          d='M353.56 391.95h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 79.635 396.946)'
        />
        <path
          d='M354.67 391.29h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 80.745 396.277)'
        />
        <path
          d='M355.24 390.95h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 81.316 395.94)'
        />
        <path
          d='M353.38 393.86a26 26 0 0 1-5.79-.58v-.11a25.71 25.71 0 0 0 6.24.58v.11zM353.33 393.28a23.66 23.66 0 0 1-5.49-.56v-.1a24.62 24.62 0 0 0 6 .55v.11zM353.42 395a27.73 27.73 0 0 1-6.06-.61v-.1a28.61 28.61 0 0 0 6.46.6v.1zM353.41 394.45a27.3 27.3 0 0 1-5.94-.6v-.1a27.72 27.72 0 0 0 6.35.58v.11zM353.35 396.08a28.57 28.57 0 0 1-6.14-.59v-.1a30.06 30.06 0 0 0 6.62.58v.1zM353.44 395.5a28.67 28.67 0 0 1-6.17-.62v-.1a29 29 0 0 0 6.56.6v.11zM353.4 397.24a31.46 31.46 0 0 1-6.47-.61v-.1a32 32 0 0 0 6.9.6v.11zM353.35 396.66a30.93 30.93 0 0 1-6.31-.58v-.11a31.66 31.66 0 0 0 6.79.58v.11zM353.44 398.4a34.8 34.8 0 0 1-6.74-.62v-.11a34 34 0 0 0 7.12.62v.11zM353.5 397.82a33 33 0 0 1-6.67-.68v-.1a33.34 33.34 0 0 0 7 .67v.11zM353.29 399.57a34.93 34.93 0 0 1-6.8-.59v-.1a36.79 36.79 0 0 0 7.34.58v.1zM353.46 399a35.21 35.21 0 0 1-6.87-.63v-.11a35.24 35.24 0 0 0 7.24.63v.11zM353.35 400.62a38.72 38.72 0 0 1-7.09-.6v-.11a39.19 39.19 0 0 0 7.57.6v.1zM353.31 400a36.21 36.21 0 0 1-6.93-.6v-.1a37.12 37.12 0 0 0 7.45.58v.12zM353.54 401.78a41.6 41.6 0 0 1-7.48-.73v-.11a41 41 0 0 0 7.77.73v.11zM353.36 401.2a39.88 39.88 0 0 1-7.21-.61v-.11a40.33 40.33 0 0 0 7.68.61v.11zM353.51 402.36a41.61 41.61 0 0 1-7.57-.71v-.1a42.5 42.5 0 0 0 7.89.7v.11zM353.43 403.52a44.44 44.44 0 0 1-7.73-.64v-.11a44.24 44.24 0 0 0 8.13.64v.11zM353.51 402.94a43.3 43.3 0 0 1-7.68-.71v-.11a42.39 42.39 0 0 0 8 .71v.11zM353.27 404.69a46.94 46.94 0 0 1-7.81-.59v-.11a47.73 47.73 0 0 0 8.37.59v.11zM353.23 404.11a43.8 43.8 0 0 1-7.62-.59v-.1a46 46 0 0 0 8.22.58v.1zM353.31 405.85a48.66 48.66 0 0 1-8.07-.61v-.1a51.33 51.33 0 0 0 8.59.6v.11zM353.29 405.27a48.34 48.34 0 0 1-7.94-.6v-.11a49.05 49.05 0 0 0 8.48.6v.11zM353.32 406.9a51.07 51.07 0 0 1-8.28-.62v-.11a52.84 52.84 0 0 0 8.8.62v.11zM353.23 406.32a50.53 50.53 0 0 1-8.09-.58v-.11a50.72 50.72 0 0 0 8.69.58v.11zM353.22 408.06a52.86 52.86 0 0 1-8.38-.58v-.11a53.37 53.37 0 0 0 9 .58v.11zM353.46 407.48a52.74 52.74 0 0 1-8.52-.71v-.11a52.84 52.84 0 0 0 8.89.71v.11zM353.18 409.23a57 57 0 0 1-8.61-.59v-.11a58.32 58.32 0 0 0 9.26.59v.11zM353.15 408.65a53.81 53.81 0 0 1-8.45-.59v-.1a55.55 55.55 0 0 0 9.13.57v.11zM353.22 410.39a60.15 60.15 0 0 1-8.87-.6v-.11a60.06 60.06 0 0 0 9.49.6v.11zM353.2 409.81a57.24 57.24 0 0 1-8.74-.6v-.11a58.51 58.51 0 0 0 9.37.6v.11zM353.27 411.44a62 62 0 0 1-9.13-.62v-.1a65.22 65.22 0 0 0 9.69.61v.11zM353.25 410.86a61.68 61.68 0 0 1-9-.61v-.11a62.5 62.5 0 0 0 9.58.61v.11zM353.17 412.6a64.56 64.56 0 0 1-9.26-.58v-.11a65.14 65.14 0 0 0 9.93.58v.11zM353.16 412a63.49 63.49 0 0 1-9.14-.58v-.11a63.89 63.89 0 0 0 9.81.58v.11z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M111.01 138.18l-.11-.02 3.93-20.77.1.02-3.92 20.77zM111.9 138.18l-.11-.02 3.75-20.84.1.02-3.74 20.84zM118.91 138.72h-.11l.16-21.24h.11l-.16 21.24z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M341.3 402.77h21.2v.11h-21.2z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-89.4 95.871 383.362)'
        />
        <path
          d='M117.41 138.57h-.11l.44-21.1h.1l-.43 21.1zM114.76 138.42l-.1-.01 2.27-21.09.11.01-2.28 21.09z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M340.24 402.69h21v.11h-21z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-88.08 91.85 386.14)'
        />
        <path
          d='M338.33 402.55h21.11v.11h-21.11z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-82.95 76.662 397.357)'
        />
        <path
          d='M337.56 402.51h21.04v.11h-21.04z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-81.33 71.304 401.14)'
        />
        <path
          d='M115.83 138.42l-.11-.01 1.45-21.09.11.01-1.45 21.09z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M343.87 413.06l-.61-.12 3.88-19.75a1.68 1.68 0 0 1 1.74-1.34l5.34.31v.62l-5.34-.31a1.05 1.05 0 0 0-1.1.84z'
          style={{
            fill: 'url(#s-2f2b1ca8ca-aU)',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M354.36 414.91l-1-.41.07-22.07a1.55 1.55 0 0 1 .75-1.32l20.16-12.18a.37.37 0 0 1 .31 0l.76.22a.38.38 0 0 1 .27.39l-.92 23.24-.93-.06V381a.39.39 0 0 0-.59-.33l-18.12 10.94a1.55 1.55 0 0 0-.75 1.33z'
          style={{
            fill: 'url(#s-2f2b1ca8ca-aV)',
          }}
          transform='translate(-233.63 -274.8)'
        />
        <path
          d='M354.57 414.78l-.28.28.07-22.1a1.55 1.55 0 0 1 .75-1.33l20-12.07a.39.39 0 0 1 .59.34v20.63a3.1 3.1 0 0 1-.91 2.2v-21.2a.39.39 0 0 0-.59-.33L356 392.16a1.56 1.56 0 0 0-.75 1.33V413a2.51 2.51 0 0 1-.68 1.78z'
          style={{
            fill: 'url(#s-2f2b1ca8ca-aW)',
          }}
          transform='translate(-233.63 -274.8)'
        />
      </g>
    </g>
  </Fragment>
)

const defaultProps = {
  children,
  viewBox,
  fillColor: null,
  fillColorRule: '&&& path, &&& use, &&& g',
  size: null
}

const propTypes = {
  fillColor: PropTypes.string,
  fillColorRule: PropTypes.string,
  viewBox: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      height: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired
    })
  ]),
  sizes: (props, name, componentName) => {
    const prop = props[name]
    if (typeof prop !== 'object') { return }
    for (let key in prop) {
      if (!prop[key] || typeof prop[key].width !== 'number' || typeof prop[key].height !== 'number') {
        return new Error(
          'Invalid prop `' + name + '` supplied to `' + componentName + '`. Validation failed.'
        )
      }
    }
  }
}

export default Object.assign(Image, {
  getDimensions,
  getCss,
  defaultProps,
  propTypes,
  displayName: '20x10'
})
